import { RxHistoryParams} from "./patient-history.model";
import { FileGeneratorList} from "./rx.model";

export class WjGridSaveModel {
    ColumnOrder: string = null;
    UserId: number = null;
    TenantId: number = null;
    WijmoId: number = null;
    Id: number = null;
    CreatedDtTm: Date = null;
    ModifiedDtTm: Date = null;
    WijmoKey: string = null;
 }

export const wijimoIdsList = {
    patientRxHistWJ: 1,
    browseRxWj: 2,
    filedQueueWj: 3,
    refQueueWJ: 4,
    erxListingWJ: 5,
    rphVerfWJ: 6,
    rxVerfWJ: 7,
    drugVerfWJ1: 8,
    drugVerfWJ2: 9,
    reviewdrugVerfWJ: 10,
    reviewRxVerfWJ: 11,
    rphDashWj: 12,
    returnToStockWJ: 13,
    reviewFollowupWJ: 14,
    gtTransHisWJ: 15,
    patListWJ: 16,
    prescListWJ: 17,
    drugListWJ: 18,
    insuListWJ: 19,
    sigListWJ: 20,
    facilityListWJ: 21,
    priceSchdListWJ: 22,
    priceListWJ: 23,
    discountListWJ: 24,
    drugWarnListWJ: 25,
    diagnosisListWJ: 26,
    rxFollowUpListWJ: 27,
    doseScheduleListWJ: 28,
    patCategoryListWJ: 29,
    presSpecalityListWJ: 30,
    payorFileListWJ: 31,
    ncpdpListWJ: 32,
    vendorListWJ: 33,
    pharmacyListWJ: 34,
    drugSearchListWJ: 35,
    usersListWJ: 36,
    rolesListWJ: 37,
    loginHistoryListWJ: 38,
    auditListWJ: 39,
    overrideLogListWJ: 40,
    phyInvListWJ: 41,
    enterInvListWJ: 42,
    viewInvListWJ: 43,
    bucketListwj: 44,
    invTransListWJ: 45,
    faxRefillListWJ: 46,
    faxLogListWJ1: 47,
    faxLogListWJ2: 48,
    batchedFaxListWJ: 49,
    incomingFaxListWJ: 50,
    erxExceptionListWJ: 51,
    unBilledRxListWJ: 52,
    patAdditionalInsuListWJ: 53,
    patDiagnosisListWJ: 54,
    patDeliveryAddListWJ: 55,
    DocumentsListWJ: 56,
    patClinicalInfoListWJ: 57,
    prescClinicAddListWJ: 58,
    prescHistoryListWJ: 59,
    drguDispHistoryListWJ: 60,
    drugMiscInfoListWJ: 61,
    drugCounsellingListWJ: 62,
    drugInsuRestListWJ: 63,
    drugInvVendorListWJ: 64,
    drugInvHistoryListWJ: 65,
    mergePatientListWJ: 66,
    profitRevDataSetListWJ: 67,
    easyRefillWizardListWJ: 68,
    rxByInsuPopupListWJ: 69,
    rxByInsuPayorPopupListWJ: 70,
    scheduledTaskListWJ: 71,
    recallDeletedRxListWJ: 72,
    drugPriceUpdateListWJ: 73,
    erxChangeReqDURListWJ: 74,
    erxChangeReqSelectDrugListWJ: 75,
    primeescPatAckListWJ: 76,
    primeescPatHistListWJ: 77,
    primeescSignByDateListWJ: 78,
    primeescSignByRxAcknListWJ: 79,
    primeescSignByRxHistListWJ: 80,
    primeescRxPickUpDetInsuWJ: 81,
    printRxWithAttDocsListWJ: 82,
    drugCounsellingWarningListWJ: 83,
    drugPriceCheckHistListWJ: 84,
    drugPriceCheckSimilarDrugListWJ: 85,
    drugPriceCheckTotalListWJ: 86,
    scheduledTaskExecHistListWJ: 87,
    revHistoryListWj: 88,
    otherInsuListWj: 89,
    documentQueueListWJ: 90,
    batchScanListWJ: 91,
    vendorInvHistListWJ: 92,
    bucketLogListWJ: 93,
    eRxExtraInfoListWJ: 94,
    rphVeryHistListWJ: 95,
    drugMMSSearchList: 96,
    viewDatSetWj: 97,
    bucketListDisplaywj: 98,
    printRxWithAttDocsListWJFill: 99,
    equivalentDrugs: 100,
    InventoryTransactionAudit: 101,
    refillQueueWJ: 102,
    insuranceListWJ: 103,
    reviewRxHistwj: 104,
    primeEDIPriceUpdateHistListWJ: 105,
    refillFlowComponent: 106,
    drugOtherPriceswj: 107,
    BenefitCheckCoverageInfoQueueWj: 108,
    rxGroupViewWJ: 109,
    equivalentBrandDrugs : 110,
    equivalentGenDrugs : 111,
    fileRecordsWJ: 112,
    cntrlSettingsWj: 113,
    insuranceToBillWj: 114,
    patientSpecificWj: 115,
    patientMedAdherenceWj: 116,
    equivalentDrugWj: 117,
    rxTransmissionLogWJ: 118,
    printRefReqWJ: 119,
    printbatchedRxsRefReqWJ: 120,
    quickRefillWJ: 121,
    faxbatchedRxsRefReqWJ: 122,
    controlResubmitListWJ: 123,
    controlgenerateListWJ: 124,
    rxBasicDisplayListWJ: 125,
    faxRefReqWJ: "faxRefSelectedRxs",
    auditListWJ2: "auditListWJ2",
    auditListWJ3: "auditListWJ3",
    auditListWJ4: "auditListWJ4",
    auditListWJ5: "auditListWJ5",
    auditListWJ6: "auditListWJ6",
    labelQueueDisplayListWJ: "LabelQueueWj",
    equivalentGenDrugsInNewRxFlow: "equivalentGenDrugsInNewRxFlow",
    topPerfomersPatientListWj:"topPerfomersPatientListWj",
    topPerfomersInsideListWj: "topPerfomersInsideListWj",
    topPerfomersPrescriberListWj: "topPerfomersPrescriberListWj",
    topPerfomersDrugListWj: "topPerfomersDrugListWj",
    topPerfomersInsListWj: "topPerfomersInsListWj",
    topPerfomersFacListWj: "topPerfomersFacListWj",
    forGroupViewWj: "forGroupViewWj",
    automatSubWj: "automatSubWj",
    CntrlRxAuditTrailWj: "CntrlRxAuditTrailWj",
    viewErrorCntrlRxWj: "viewErrorCntrlRxWj",
    logicalAccessCtrlWj: "logicalAccessCtrlWj",
    messageLogWj: "messageLogWj",
    messageQueueWj: "messageQueueWj",
    rxGroupViewDetailsWJ: "rxGroupViewDetailsWJ",
    controlFileErrorForNY:"controlFileErrorForNY",
    controlFileError:"controlFileError",
    refillDueMsgOuterWj: "refillDueMsgOuterWj",
    refillDueMsgInnerWj: "refillDueMsgInnerWj",
    refillDueMsgIndividualWj: "refillDueMsgIndividualWj",
    geographyDistributionWj: "geographyDistributionWj",
    drugThearpauticWj: "drugThearpauticWj",
    reverseClaim: "reverseClaim",
    inventoryListwj:"inventoryListwj",
    insuaranceListeRxListwj:"insuaranceListeRxListwj",
    insuExceptionListWJ:"insuExceptionListWJ",
    physicalInvStatusRecWJ: "physicalInvStatusRecWJ",
    physicalInvRecWJ: "physicalInvRecWJ",
    labelDesignListWJ: "labelDesignListWJ",
    compoundIngListWJ: "compoundIngListWJ",
    prescriberSearchWJ :"prescriberSearchWJ",
    InsuFileSearchWJ: "InsuFileSearchWJ",
    DurValWj: "DurValWj",
    manageInvwj:"manageInvWj",
    physicalInvWj:"physicalInvWj",
    receiveInvWj: "receiveInvWj",
    dispensedInvWj:"dispensedInvWj",
    DURValNewRxWJ: "DURValNewRxWJ",
    NoteHistory: "NoteHistory",
    prescClinicAddListPopupWJ:"prescClinicAddListPopupWJ",
    PrescTypeFileWJ : "PrescTypeFileWJ",
    edi810SuccessfulRecords: "edi810SuccessfulRecords",
    edi810UnSuccessfulRecords: "edi810UnSuccessfulRecords",
    refReqPrescriberWj: "refReqPrescriberWj",
    drugCatoriesList: "drugCatoriesList",
    intakeQueueWjList:  "intakeQueueWjList",
    fileGeneratorList:  "fileGeneratorList",
    iouWjList: "iouWjList",
    DPVVerfListWJ: "DPVVerfListWJ",
    NoteCatoriesList: "NoteCatoriesList",
    InvReconRepWj: "InvReconRepWj",
    vaccnImmunGeneratorListWJ: "vaccnImmunGeneratorListWJ",
    InvReconDrugWj: "InvReconDrugWj",
    customReportListWJ: "customReportListWJ",
    deferredEquivalentsWJ : "deferredEquivalentsWJ",
    prevoiusRefillsWJ: "prevoiusRefillsWJ",
    prevoiusFillsWJ: "prevoiusFillsWJ",
    dscsaListWJ : "dscsaListWJ",
    RxHistoryCurrentView : "RxHistoryCurrentView",
    pillCounterListWJ: "pillCounterListWJ",
    remittanceDataSetListWJ: "remittanceDataSetListWJ",
    drugSuggestListWj : "drugSuggestListWj",
    drugEquListWj : "drugEquListWj",
    paQueueWj : "paQueueWj",
    drugRequesteDetails : "drugRequesteDetails",
    InvRecnSubWj: "InvRecnSubWj",
    RxsTransferIn: "RxsTransferIn",
    RxsTransferInforNon: "RxsTransferInforNon",
    PatientExternalHistoryWJ: "PatientExternalHistoryWJ",
    patientSuggestListWj : 'patientSuggestListWj',
    erxListingWJRequestView: "erxListingWJRequestView",
    submissionLog: "submissionLog",    
    ivrWorkStationsListWj : 'ivrWorkStationsListWj',
    prescriberSuggestListWj : 'prescriberSuggestListWj',
    ivrCallLogListWj : 'ivrCallLogListWj',
    patientMatchListWj : 'patientMatchListWj',
    prescriberMatchListWj : 'prescriberMatchListWj',
    insuracneMatchListWj : 'insuracneMatchListWj',
    extPharmacyMatchListWj : 'extPharmacyMatchListWj',
    rxTransferListWj : 'rxTransferListWj',
};

export class DefaultHeaders {
    equivalentBrandDrugs = [
        {header: "Drug Name", isVisible: true, width: "2.6*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Size", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Pck/Unit Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Pck/Unit AWP", isVisible: true, width: "1.6*"  ,minWidth: 50},
        {header: "Made By", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Last Disp", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "D/C Date", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Drug Type", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: "1.4*" ,minWidth: 50},        
        {header: "Brand?", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Equ.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Gen.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is Pref?", isVisible: true, width: "0.9*" ,minWidth: 50},        
        {header: "Is 340B", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Inv?", isVisible: true, width: "*" ,minWidth: 50},
    ]
    equivalentGenDrugs = [
        {header: "Drug Name", isVisible: true, width: "2.6*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Size", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Pck/Unit Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Pck/Unit AWP", isVisible: true, width: "1.6*"  ,minWidth: 50},
        {header: "Made By", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Last Disp", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "D/C Date", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Drug Type", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: "1.4*" ,minWidth: 50},        
        {header: "Brand?", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Equ.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Gen.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is Pref?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is 340B", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Inv?", isVisible: true, width: "*" ,minWidth: 50},
    ]
    rxGroupViewWJ = [
        {header: "Rx#", isVisible: true, width: 142 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Total Fills", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total Qty Disp", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total Qty Remaining", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total CoPay", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total Price", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total Days", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Total Profit", isVisible: true, width: 200 ,minWidth: 50},
    ];

    rxGroupViewDetailsWJ = [
        {header: "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 45 ,minWidth: 45},
        {header: "Ref#", isVisible: true, width: 45 ,minWidth: 45},
        {header: "Fill#", isVisible: true, width: 45 ,minWidth: 45},
        {header: "Insurance", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Due in Days", isVisible: true, width: 75 ,minWidth: 50},
        {header: "DVrf?", isVisible: true, width: 55 ,minWidth: 50},
        {header: "PVrf?", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Rx Vrf?", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Copay", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Profit Amount", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Label Printed?", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Rx Origin", isVisible: true, width: 75 ,minWidth: 50},
    ];

   patientRxHistWJ = [
        {header: "Rx#", isVisible: true,  width: 87 ,minWidth: 50},
        {header: "Auth#", isVisible: true,  width: 45 ,minWidth: 45},
        {header: "Ref#", isVisible: true, width: 37 ,minWidth: 37},
        {header: "Fill#", isVisible: true, width: 34 ,minWidth: 34},
        {header: "Insurance", isVisible: true,  width: 69 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: 259 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true ,  width: 87 ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: 65 ,minWidth: 50},
        {header: "Qty trans. Out", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 163 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 259 ,minWidth: 50},
        {header: "NDC", isVisible: true,  width: 100 ,minWidth: 50},
        {header: "Price", isVisible: true,  width: 59 ,minWidth: 50},
        {header: "Due in Days", isVisible: true, width: 53 ,minWidth: 50},
        {header: "DVrf?", isVisible: true, width: 43 ,minWidth: 43},
        {header: "PVrf?", isVisible: true, width: 42 ,minWidth: 42},
        {header: "Rx Vrf?", isVisible: true, width: 40 ,minWidth: 40},
        {header: "Copay", isVisible: true, width: 49 ,minWidth: 49},
        {header: "Profit Amount", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Label Printed?", isVisible: true, width: 59 ,minWidth: 50},
        {header: "Rx Origin", isVisible: false, width: 87 ,minWidth: 50},
        {header: "IsDrugDis", isVisible: false, width: 69 ,minWidth: 50},
        {header: "Total Amount", isVisible: false, width: 60 ,minWidth: 50},
        {header: "Insurance Paid", isVisible: false, width: 69 ,minWidth: 50},
        {header: "Sig Lines", isVisible: false, width: 184 ,minWidth: 50},
        {header: "Tag Name", isVisible: false, width: 46 ,minWidth: 46},
        {header: "Delivery Method", isVisible: false, width: 62 ,minWidth: 50},
        {header: "Refills Left", isVisible: false, width: 49 ,minWidth: 49},
        {header: "Rf and Def Due Date", isVisible: false, width: 85 ,minWidth: 50},
        {header: "HasDoc", isVisible: false, width: 57 ,minWidth: 50},
        {header: "TQty Disp.", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Patient Pay", isVisible: false, width: 53 ,minWidth: 50},
    ];

    browseRxWj = [
        {header: "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 35 ,minWidth: 35},
        {header: "Fill#", isVisible: true, width: 35 ,minWidth: 35},
        {header: "Auth#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Insu Code", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Qty-Dis", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Due Days", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Fill Date & Time", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Ord-Date", isVisible: true, width: 80 ,minWidth: 50},
        {header: "DAW", isVisible: true, width: 50 ,minWidth: 50},
        {header: "R.P.H", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Tech.", isVisible: true, width: 80 ,minWidth: 50},
        {header: "RxNotes", isVisible: true, width: 117 ,minWidth: 50},
        {header: "Paid", isVisible: false, width: 105 ,minWidth: 50},
        {header: "Billed", isVisible: false, width: 105 ,minWidth: 50},
        {header: "NDC", isVisible: false, width: 107 ,minWidth: 50},
        {header: "Co-Pay", isVisible: false, width: 105 ,minWidth: 50},
        {header: "Drug Category", isVisible: false, width: 150 ,minWidth: 50},
        {header: "Class", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Delivery Method", isVisible: false, width: 117 ,minWidth: 50},
        {header: "DVrf?", isVisible: false, width: 50 ,minWidth: 50},
        {header: "PVrf?", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Sig Lines", isVisible: false, width: 150 ,minWidth: 50},
        {header: "Tag Name", isVisible: false, width: 150 ,minWidth: 50},
        {header: "Patient Address", isVisible: false, width: 150 ,minWidth: 50},
        {header: "Label Printed?", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Profit Amount", isVisible: true, width: 73 ,minWidth: 50},
        {header: "Day's Supply", isVisible: false, width: 73 ,minWidth: 50},
        {header: "Prescriber Phone#", isVisible: false, width: 120 ,minWidth: 50},
        {header: "Prescriber Address", isVisible: false, width: 166 ,minWidth: 50},
        {header: "Picked Up Date & Time", isVisible: false, width: 173 ,minWidth: 50},
        {header: "Facility", isVisible: false, width: 120 ,minWidth: 50},
        {header: "Is340B", isVisible: false, width: 73 ,minWidth: 50},
        {header: "Inv Bucket Name", isVisible: false, width: 73 ,minWidth: 50},
    ];
   documentQueueListWJ = [
        {header: "Document ID", isVisible: true, width: 142 ,minWidth: 50},
        {header: "Attach", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Tag Patient", isVisible: true, width: 190 ,minWidth: 50},
        {header: "Delivery Priority", isVisible: true, width: 154 ,minWidth: 50},
        {header: "Fill Rx", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Scan Date", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Title", isVisible: true, scheduledTaskListWJwidth: 158 ,minWidth: 50},
        {header: "Marked By", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Comments", isVisible: true, width: 90 ,minWidth: 50}
    ];
    batchScanListWJ = [
        {header: "Document ID", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Rx Reference No", isVisible: true, width: "2.7*" ,minWidth: 50},
        {header: "Scan Date", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Doc Type Text", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "3*" ,minWidth: 50}
    ];

    filedQueueWj = [
        {header: "Rx#", isVisible: true, width: 57 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 49 ,minWidth: 49},
        {header: "Ref#", isVisible: true, width: 46 ,minWidth: 46},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 40},
        {header: "Fill Date", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Defer Due Date", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 168 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true, width: 56 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 53 ,minWidth: 50},
        {header: "T.Price", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 66 ,minWidth: 50},
        {header: "Facility Code", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Facility Name", isVisible: true, width: 76 ,minWidth: 50},
        {header: "Tag Name", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Sig Code", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Sig Desc.", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Deferred Reason", isVisible: true, width: 150 ,minWidth: 50}
    ];

    refQueueWJ = [
        {header: "Rx#", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Date-Time Queued", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Source", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Added By", isVisible: true, width: 135 ,minWidth: 50},
        {header: "S.Days", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Due Date", isVisible: true, width: 86 ,minWidth: 50},
        {header: "Last Refill Date", isVisible: true, width: 111 ,minWidth: 50},
        {header: "Ins", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Ref. DD Threshold", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Pickup Due Date", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Picked Up", isVisible: true, width: 86 ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: 111 ,minWidth: 50},
        {header: "Pickup Time", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Refill Expiration Date", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Is Maintenance Drug", isVisible: true, width: 98 ,minWidth: 50},

    ];

    erxListingWJ = [
        {header: "Message Type", isVisible: true, width: 150, minWidth: 150},
        {header: "Status", isVisible: true, width: 178, minWidth: 178},
        {header: "Date & Time", isVisible: true, width: 121, minWidth: 121},
        {header: "Patient Name", isVisible: true, width: 192, minWidth: 192},
        {header: "Prescriber Name", isVisible: true, width: 183, minWidth: 183},
        {header: "Drug Name", isVisible: true, width: 275, minWidth: 275},
        {header: "Last Filled", isVisible: true, width: 70, minWidth: 70},
        {header: "Auth#", isVisible: true, width: 43, minWidth: 43},
        {header: "Rx#", isVisible: true, width: 58, minWidth: 58},
        {header: "Rph Notes", isVisible: true, width: 51, minWidth: 51},
        {header: "Prescriber Notes", isVisible: true, width: 51, minWidth: 65},
        // {header: "Printed", isVisible: true, width: 56, minWidth: 56},
        {header: "Drug Class", isVisible: true, width: 56, minWidth: 56},
        {header: "NABP", isVisible: false, width: 64, minWidth: 64},
        //{header: "Speciality type", isVisible: true, width: 94, minWidth: 94},
        {header: "SPI#", isVisible: false, width: 111, minWidth: 111},
        {header: "Patient Phone#", isVisible: false, width: 102, minWidth: 102},
        {header: "Primary Insurance", isVisible: false, width: 57, minWidth: 57},
        {header: "Last Removed by", isVisible: false, width: 78, minWidth: 78},
        {header: "eRx Facility", isVisible: false, width: 69, minWidth: 69},
        {header: "Facility", isVisible: false, width: 70, minWidth: 70},
        {header: "Refill Response Status", isVisible: false, width: 79, minWidth: 79},
    ];

    rphVerfWJ = [
        {header: "Rx#", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Fill#", isVisible: true, width: 36 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 171 ,minWidth: 50},
        {header: "Filled Date", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Rph Verification Status", isVisible: true, width: 94 ,minWidth: 50},
        {header: "Rph Verified DtTm", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Rx Verification Status", isVisible: true, width: 94 ,minWidth: 50},
        {header: "Drug Pick Verification Status", isVisible: true, width: 94 ,minWidth: 50},
        {header: "Follow-Up Reason", isVisible: true, width: 102 ,minWidth: 50},
        {header: "Ins Name", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Billed", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Paid", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 165 ,minWidth: 50},
        {header: "Class", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Picked up", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Facility Name", isVisible: true, width: 105 ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 42 ,minWidth: 42},
        {header: "Delivery Mode", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Filled By", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Verified By R.Ph", isVisible: true, width: 105 ,minWidth: 50}
    ];

    rxVerfWJ = [
        {header: "Rx#", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Fill#", isVisible: true, width: 36 ,minWidth: 36},
        {header: "Patient Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 171 ,minWidth: 50},
        {header: "Filled Date", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Verification Status", isVisible: true, width: 94 ,minWidth: 50},
        {header: "Verified DtTm", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Ins Name", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Billed", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Paid", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 165 ,minWidth: 50},
        {header: "Class", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Picked up", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Facility Name", isVisible: true, width: 105 ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 42 ,minWidth: 42},
        {header: "Delivery Mode", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Filled By", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Verified By R.Ph", isVisible: true, width: 105 ,minWidth: 50}
    ];

    drugVerfWJ1 = [
        {header: "Rx#", isVisible: true, width: 136 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 104 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 102 ,minWidth: 50},
        {header: "Patient", isVisible: true, width: 280 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 280 ,minWidth: 50},
        {header: "Drug", isVisible: true, width: 280 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Qty Dispensed", isVisible: true, width: 129 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 256 ,minWidth: 50},
        {header: "Qty in hand", isVisible: true, width: 228 ,minWidth: 50}
    ];

    drugVerfWJ2 = [
        {header: "Rx#", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 160 ,minWidth: 50},
        {header: "Pharmacist", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Tech", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Date Time Verified", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Result", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Drug", isVisible: true, width: 359 ,minWidth: 50},
        {header: "Qty In Hand", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Qty Dispensed", isVisible: true, width: 116 ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: 116 ,minWidth: 50},
        {header: "Lot Expiration Date", isVisible: true, width: 116 ,minWidth: 50},
        {header: "GTIN#", isVisible: true, width: 116 ,minWidth: 50},
        {header: "Serial#", isVisible: true, width: 116 ,minWidth: 50}
    ];

    reviewdrugVerfWJ = [
        {header: "User", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Tech", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Verified", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Bottle NDC", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Result", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "3.5*" ,minWidth: 50},
        {header: "Filled", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Tr Count", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Verif Qty", isVisible: true, width: "1.1*" ,minWidth: 50}
    ];

    reviewRxVerfWJ = [
        {header: "Rx#", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 39 ,minWidth: 39},
        {header: "Fill#", isVisible: true, width: 33 ,minWidth: 33},
        {header: "Patient Name", isVisible: true, width: 137 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 143 ,minWidth: 50},
        {header: "Drug Class", isVisible: true, width: 43 ,minWidth: 50},
        {header: "User", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Verified", isVisible: true, width: 84 ,minWidth: 50},
        {header: "Billed", isVisible: true, width: 137 ,minWidth: 50},
        {header: "Paid", isVisible: true, width: 131 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 41 ,minWidth: 41},
        {header: "Days", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Filled", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Pharmacist Verification Status", isVisible: true, width: 212 ,minWidth: 50},
        {header: "Rx Verification Status", isVisible: true, width: 106 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 121 ,minWidth: 50},
        {header: "Tr Count", isVisible: true, width: 48 ,minWidth: 48}
    ];

    rphDashWj = [
        {header: "Rx#", isVisible: true, width: 69 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 39 ,minWidth: 39},
        {header: "Fill#", isVisible: true, width: 38 ,minWidth: 38},
        {header: "Status", isVisible: true, width: 53 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 91 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 168 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 282 ,minWidth: 50},
        {header: "Qty Disp", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 56 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 86 ,minWidth: 50},
        {header: "Pat.Pay", isVisible: true, width: 58 ,minWidth: 50},
        {header: "Ins.Paid Amt", isVisible: true, width: 116 ,minWidth: 50},
        {header: "Drug PV", isVisible: true, width: 91 ,minWidth: 50},
        {header: "Rph Verf.", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 137 ,minWidth: 50},
        {header: "Order Date", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Under paid", isVisible: true, width: 49 ,minWidth: 49},
        {header: "Defer Due Date", isVisible: true, width: 83 ,minWidth: 50},
        {header: "Rx Notes", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Rx Verification", isVisible: true, width: 93 ,minWidth: 50},
    ];

    returnToStockWJ = [
        {header: "Patient Name", isVisible: true, width: 166 ,minWidth: 50},
        {header: "Patient Ph#", isVisible: true, width: 104 ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 38 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 39 ,minWidth: 50},
        {header: "Unpicked For", isVisible: true, width: 66 ,minWidth: 50},
        {header: "Reversal Status", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 88 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 230 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 56 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 230 ,minWidth: 50},
        {header: "Prescriber Ph#", isVisible: false, width: 47 ,minWidth: 50},
        {header: "Ins", isVisible: true, width: 54 ,minWidth: 50},
        {header: "Copay", isVisible: true, width: 73 ,minWidth: 50},
        {header: "Price", isVisible: true, width: 145 ,minWidth: 50},
        {header: "Ins.Amt.Paid", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 60 ,minWidth: 50},
        {header: "PH", isVisible: true, width: 52 ,minWidth: 50},
        {header: "Group#", isVisible: false, width: 140 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Tag Name", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Facility", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Rx Notes", isVisible: true, width: 74 ,minWidth: 50},
    ];

    reviewFollowupWJ = [
        {header: "Rx#", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 48 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 48 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 166 ,minWidth: 50},
        {header: "DOB", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 113 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 58 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 166 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 166 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Tag Name", isVisible: true, width: 194 ,minWidth: 50},
        {header: "Price", isVisible: true, width: 54 ,minWidth: 50},
        {header: "Pickedup Rx", isVisible: true, width: 69 ,minWidth: 50},
        {header: "Facility", isVisible: true, width: 54 ,minWidth: 50},
        {header: "Notes", isVisible: true, width: 54 ,minWidth: 50},
    ];

    gtTransHisWJ = [
        {header: "Rx#", isVisible: true, width: 76 ,minWidth: 50},
        {header: "GroupID", isVisible: true, width: 48 ,minWidth: 50},
        {header: "BatchID", isVisible: true, width: 48 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 34 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 33 ,minWidth: 50},
        {header: "PatientName", isVisible: true, width: 113 ,minWidth: 50},
        {header: "QtyDis", isVisible: true, width: 76 ,minWidth: 50},
        {header: "Day", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 189 ,minWidth: 50},
        {header: "Fill Date Time", isVisible: true, width: 189 ,minWidth: 50},
        {header: "Insurance Code", isVisible: true, width: 76 ,minWidth: 50},
        {header: "IngredientCostPaid", isVisible: true, width: 76 ,minWidth: 50},
        {header: "Copay", isVisible: true, width: 76 ,minWidth: 50},
        {header: "TotalAmountPaid", isVisible: true, width: 76 ,minWidth: 50},
        {header: "ProfFeePaid", isVisible: true, width: 76 ,minWidth: 50},
        {header: "RejectedReason", isVisible: true, width: 113 ,minWidth: 50},
        {header: "TransResult", isVisible: true, width: 69 ,minWidth: 50},
        {header: "TransmissionStatus", isVisible: true, width: 110 ,minWidth: 50},
    ];

    patListWJ = [
        {header: "Last Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "First Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Email", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Date Of Birth", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Gender", isVisible: true, width: "0.52*" ,minWidth: 50},
        {header: "IsActive", isVisible: true, width: "0.62*" ,minWidth: 50},
        {header: "Ins.Type", isVisible: true, width: "1.75*" ,minWidth: 50},
        {header: "Policy#", isVisible: true, width: "0.98*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "City", isVisible: false, width: "1.5*" ,minWidth: 50},
        {header: "State", isVisible: false, width: "0.8*" ,minWidth: 50},
        {header: "Zip", isVisible: false, width: "0.8*" ,minWidth: 50},
        {header: "Telephone#", isVisible: true, width: "0.98*" ,minWidth: 50},
        {header: "Pat.Chart#", isVisible: true, width: "0.87*" ,minWidth: 50},
        {header: "Facility Code", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Created By", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Created Date", isVisible: true, width: "0.92*" ,minWidth: 50},
        {header: "Ethnicity", isVisible: false, width: "1*" ,minWidth: 50},
        {header: "Pat. Race", isVisible: false, width: "1*" ,minWidth: 50},
    ];

    prescListWJ = [
        {header: "Last Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "First Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Quick Code", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "License#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "NPI#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Mobile#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Telephone#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Work#", isVisible: true, width: "0.9*" ,minWidth: 50},
    ];

    drugListWJ = [
        {header: "Drug Name", isVisible: true, width: 250 ,minWidth: 50},
        {header: "Strength", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Units", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Form", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Size", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Made By", isVisible: true, width: 105 ,minWidth: 50},
        {header: "AWP Price", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Last Dispensed", isVisible: true, width: 113 ,minWidth: 50},
        {header: "Gen. Avail?", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Quick Code", isVisible: true, width: 105 ,minWidth: 50},
        {header: "IsBrand", isVisible: true, width: 65 ,minWidth: 50},
        {header: "Cost Price", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Drug Class", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Drug Type", isVisible: true, width: 85 ,minWidth: 50},
        {header: "D/C Date", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Stock Qty", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: 113 ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: 113 ,minWidth: 50},
        {header: "Exp. Date", isVisible: true, width: 105 ,minWidth: 50}
      //  {header: "Billing NDC", isVisible: true, width: 105 ,minWidth: 50},
    ];

    insuListWJ = [
        {header: "Insurance Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Pharmacy ID", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "BIN", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Processor Ctrl", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Version", isVisible: true, width: "0.5*" ,minWidth: 50},
       // {header: "Communication", isVisible: true, width: 116 ,minWidth: 50},
        {header: "Remarks", isVisible: true, width: "2*" ,minWidth: 50},
    ];

    sigListWJ = [
        {header: "Sig Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Language", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Sig Description", isVisible: true,  width: "3*" ,minWidth: 50},
        {header: "Daily Dose", isVisible: true,  width: "2*" ,minWidth: 50},
    ];

    facilityListWJ = [
        {header: "Facility Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Address 1", isVisible: true,width: "1*" ,minWidth: 50},
        {header: "Address 2", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Phone# 1", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Phone# 2", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "PO Form", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "PO Text", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Comments", isVisible: true, width: "1*" ,minWidth: 50},
    ];

    priceSchdListWJ = [
        {header: "Price Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Name", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Base", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "SType", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Mark Up", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Pro Fee", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "RoundTo", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Up Charge", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Min Charge", isVisible: true,  width: "1*" ,minWidth: 50}
    ];

    priceListWJ = [
        {header: "NDC", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Strength", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Form", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Price Code", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Qty1", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Price1", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty2", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Price2", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty3", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Price3", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty4", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Price4", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty5", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Price5", isVisible: true, width: "1.2*" ,minWidth: 50},
    ];

    discountListWJ = [
        {header: "Discount Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Discount Name", isVisible: true,width: "1*" ,minWidth: 50},
        {header: "Base Amount(or)Percentage", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Discount", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    drugWarnListWJ = [
        {header: "Warning", isVisible: true, width: "*" ,minWidth: 50},
        {header: "English Description", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Spanish Description", isVisible: true, width: "3*" ,minWidth: 50}
    ];

    diagnosisListWJ = [
        {header: "Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Diagnosis Description", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Type", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    rxFollowUpListWJ = [
        {header: "Tag Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Tag Status", isVisible: true, width: "2*" ,minWidth: 50},
    ];

    doseScheduleListWJ = [
        {header: "Dose Schedule Name", isVisible: true, width: "3.9*" ,minWidth: 50},
        {header: "Dose Time Type", isVisible: true, width: "3.9*" ,minWidth: 50},
        {header: "Repeat Days", isVisible: true, width: "3.9*" ,minWidth: 50},
        {header: "Dose Per Day", isVisible: true, width: "3.9*" ,minWidth: 50},
    ];

    patCategoryListWJ = [
        {header: "Category Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Category Name", isVisible: true, width: "2*" ,minWidth: 50},
    ];

    presSpecalityListWJ = [
        {header: "Speciality Code", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Description", isVisible: true, width: "3*" ,minWidth: 50},
    ];

    payorFileListWJ = [
        {header: "Payor Ins ID", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Payor Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Contact Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Address", isVisible: true,width: "1*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "3*" ,minWidth: 50}
    ];

    ncpdpListWJ = [
        {header: "Set ID", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Set Name", isVisible: true, width: 204 ,minWidth: 50},
        {header: "Transaction Type", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Patient", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Claims", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Pharmacy Provider", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 150 ,minWidth: 50},
        {header: "COB", isVisible: true, width: 150 ,minWidth: 50},
        {header: "WCOM", isVisible: true, width: 150 ,minWidth: 50},
        {header: "DUR", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Pricing", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Coupon", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Compound", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Prior App", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Clinical", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Additional Doc", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Facility", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Narrative", isVisible: true, width: 150 ,minWidth: 50}
    ];

    vendorListWJ = [
        {header: "Vendor ID", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Vendor Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Website", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Contact Person", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Default Bucket", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Comments", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Status", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Auto Close", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Last Order Date", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Last Received Date", isvisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Supports EDI", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Send Vendo Cost Price", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Use Qnt Pack For Price Call For 832", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "EDI Vendor Code", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Use Qnt Pack For Price Call For 810", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Price Qualifier", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Update Price", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Cost Qualifier", isVisible: false, width: "1.1*" ,minWidth: 50},
        {header: "Update Cost", isVisible: false, width: "1.1*" ,minWidth: 50}
    ];

    pharmacyListWJ = [
        {header: "Pharmacy Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "NPI#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "NCPDP ID", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    drugSearchListWJ = [
        {header: "NDC", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Shape", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Color Front", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Color Back", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "ID Front", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "ID Back", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Description", isVisible: true, width: "*" ,minWidth: 50}
    ];

    usersListWJ = [
        {header: "Initials", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Roles", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Phone# 1", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Phone# 2", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Active", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Locked Status", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Provider ID", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Provider ID Type", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Remarks", isVisible: true, width: "1.7*" ,minWidth: 50}
    ];

    rolesListWJ = [
        {header: "Role Name", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "Role Type", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Description", isVisible: true, width: "5*" ,minWidth: 50}
    ];

    loginHistoryListWJ = [
        {header: "Login ID", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "IP Address", isVisible: true, width: "1.9*" ,minWidth: 50},
        {header: "Login Date", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Login Time", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Logout Date", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Logout Time", isVisible: true, width: '1.7*' ,minWidth: 50},
        {header: "Session Time", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "User Roles", isVisible: true, width: "3*" ,minWidth: 50}
    ];

    auditListWJ = [
        {header: "Item", isVisible: true, width: 326 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 139 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 177 ,minWidth: 50},
        {header: "Entity Data", isVisible: true, width: 167 ,minWidth: 50},
        {header: "User", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 334 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 326 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 275 ,minWidth: 50}
    ];

    auditListWJ2 = [
        {header: "Item", isVisible: true, width: 237 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Rx#-Ref#-Fill#", isVisible: true, width: 117 ,minWidth: 50},
        {header: "User", isVisible: true, width: 72 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 420 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 424 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 170 ,minWidth: 50}
    ];

    auditListWJ3 = [
        {header: "Item", isVisible: true, width: 237 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 161 ,minWidth: 50},
        {header: "User", isVisible: true, width: 72 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 170 ,minWidth: 50}
    ];

    auditListWJ4 = [
        {header: "Item", isVisible: true, width: 230 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 168 ,minWidth: 50},
        {header: "User", isVisible: true, width: 72 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 170 ,minWidth: 50}
    ];

    auditListWJ5 = [
        {header: "Item", isVisible: true, width: 237 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 161 ,minWidth: 50},
        {header: "User", isVisible: true, width: 72 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 170 ,minWidth: 50}
    ];

    auditListWJ6 = [
        {header: "Item", isVisible: true, width: 237 ,minWidth: 50},
        {header: "Related To", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Action Performed", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: 161 ,minWidth: 50},
        {header: "User", isVisible: true, width: 72 ,minWidth: 50},
        {header: "Old Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "New Value", isVisible: true, width: 400 ,minWidth: 50},
        {header: "DateTime", isVisible: true, width: 170 ,minWidth: 50}
    ];


    overrideLogListWJ = [
        {header: "Initials", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Override Initials", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Document Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Function Name", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Override Date", isVisible: true, width: "1.5**" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Result", isVisible: true, width: "2*" ,minWidth: 50}
    ];

    phyInvListWJ = [
        {header: "NDC", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Manufacturer", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "New Qty", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Old Qty", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Date", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "User ID", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Comments", isVisible: true, width: "1.2*" ,minWidth: 50}
    ];

    enterInvListWJ = [
        {header: "NDC", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2.3*" ,minWidth: 50},
        {header: "Manufacturer", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Date Received", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Comment", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Unit Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty Received", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: "2*" ,minWidth: 50}
    ];

    viewInvListWJ = [
        {header: "Date Received", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 250 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 168 ,minWidth: 50},
        {header: "Made by", isVisible: true, width: 119 ,minWidth: 50},
        {header: "Bucket Name", isVisible: false, width: 119 ,minWidth: 50},
        {header:  "Vendor Name", isVisible: true, width: 130 ,minWidth: 50},
        {header:  "Account", isVisible: false, width: 150 ,minWidth: 50},
        {header: "Qty.Rec", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Unit Cost", isVisible: true, width: 115 ,minWidth: 50},
        {header: "Ext.Cost", isVisible: true, width: 115 ,minWidth: 50},
        {header: "Pkgs.Recv", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Type Name", isVisible: true, width: 129 ,minWidth: 50},
        {header: "Reference", isVisible: false, width: 119 ,minWidth: 50},
        {header: "PO#", isVisible: false, width: 121 ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Expiration Date", isVisible: true, width: 135 ,minWidth: 50},
        {header: "Therapeutic Code", isVisible: false, width: 122 ,minWidth: 50}
    ];

    bucketListwj = [
        {header: "Bucket Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Bucket Context Type", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Default", isVisible: true, width: "3*" ,minWidth: 50}
    ];
    bucketListDisplaywj = [
        {header: "Bucket Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Bucket Context Type", isVisible: true, width: "2*" ,minWidth: 50}
    ];

    invTransListWJ = [
        {header: "Type Name", isVisible: true, width: "7*" ,minWidth: 50},
        {header: "Trans Type", isVisible: true, width: "8*" ,minWidth: 50}
    ];

    faxRefillListWJ = [
        {header: "Rx#", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 250 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 190 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Req. Sent Date", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Mark Date", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Comments", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Reply Received", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Ref. Req. Mode", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Already Processed", isVisible: true, width: 142 ,minWidth: 50},
        {header: "Refills Left", isVisible: true, width: 65 ,minWidth: 50},
        {header: "Qty Remaining", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Available EQ Rxs", isVisible: true, width: 89 ,minWidth: 50},
        {header: "Failed Reason", isVisible: true, width: 200 ,minWidth: 50}
    ];

    faxLogListWJ1 = [
        {header: "Rx#", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Initiated From", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Cancel Status", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Fax To", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Fax From", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Reply Date", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Status", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "User", isVisible: true, width: "1.8*" ,minWidth: 20}
    ];

    faxLogListWJ2 = [
        {header: "Rx#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Initiated From", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Fax To", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Fax From", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Prescriber Phone", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Sent Date & Time", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Status", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Failed Reason", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "User", isVisible: true, width: "1.8*" ,minWidth: 20}
    ];

    batchedFaxListWJ = [
        {header: "From Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "To Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "To Fax#", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Fax Date", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Time Info", isVisible: true, width: "2.1*" ,minWidth: 50}
    ];

    incomingFaxListWJ = [
        {header: "Date Received", isVisible: true, width: 140 ,minWidth: 50},
        {header: "From Fax#", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Comments", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Sender", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Receiving Fax#", isVisible: true, width: 139 ,minWidth: 50}
    ];

    erxExceptionListWJ = [
        {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Patient", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Drug", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Ord Qty", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Date Ord", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Rph/Tech", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Rph Notes", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Rph Vrf", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Presc Notes", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Sig", isVisible: true, width: 326 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 40 ,minWidth: 50},
        {header: "DAW", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Tag Name", isVisible: true, width: 90 ,minWidth: 50},
    ];

    unBilledRxListWJ = [
        {header: "Rx#", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Auth Refs", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "PatientName", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "QtyDisp.", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Days", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "DrugName", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Ins. Code", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "RejectCode", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "RejectReason", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "TransmissionStatus", isVisible: true, width: "1.5*" ,minWidth: 50}
    ];

    patAdditionalInsuListWJ = [
        {header: "Ins Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Insurer Name", isVisible: true, width: "1.9*" ,minWidth: 50},
        {header: "Is 340B?", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Ins ID", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "PC", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Priority", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Group#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "C.H.Last Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "C.H.First Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Active for Patient", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "BIN", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Comments", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Assig", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Rel.", isVisible: true, width: "0.7*" ,minWidth: 50}
    ];

    patDiagnosisListWJ = [
        {header: "Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Diagnosis Description", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "Type", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    patDeliveryAddListWJ = [
        {header: "Address1", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "Address2", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "1.4*" ,minWidth: 50}
    ];

    DocumentsListWJ = [
        {header: "Date", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Document Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Print With Label", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Title", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Category", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Subcategory", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Comment", isVisible: true, width: "1.2*" ,minWidth: 50}
    ];

    patClinicalInfoListWJ = [
        {header: "Date and Time", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Dimension", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Measurement Unit", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Measurement Value", isVisible: true, width: "3.5*" ,minWidth: 50}
    ];

    prescClinicAddListWJ = [
        {header: "SPI#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Address1", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Address2", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "ZipCode", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Active", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Telephone#", isVisible: true, width: "1*" ,minWidth: 50},

    ];

    prescHistoryListWJ = [
        {header: "Patient Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Ins. Type", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Strength", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Form", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Tot. Amt", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "3.5*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: "1.7*" ,minWidth: 50}
    ];

    drguDispHistoryListWJ = [
        {header: "Patient Name", isVisible: true, width: "3.5*" ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Status", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "TotalAmount", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Patient Copay", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "QtyDisp", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Days", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Ins.Type", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "3.5*" ,minWidth: 50}
    ];

    drugMiscInfoListWJ = [
        {header: "Lot#", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Expiration Date", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "IsActive", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    drugCounsellingListWJ = [
        {header: "Age Category", isVisible: true, width: 131 ,minWidth: 50},
        {header: "From Age Days", isVisible: true, width: 93 ,minWidth: 50},
        {header: "To Age Days", isVisible: true, width: 88 ,minWidth: 50},
        {header: "Min Daily Units", isVisible: true, width: 84 ,minWidth: 50},
        {header: "Max Daily Units", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Usual Daily Units", isVisible: true, width: 86 ,minWidth: 50},
        {header: "Ingredient Name", isVisible: true, width: 121 ,minWidth: 50},
        {header: "Min Daily Dose", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Max Daily Dose", isVisible: true, width: 101 ,minWidth: 50},
        {header: "Usual Daily Dose", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Frequency", isVisible: true, width: 89 ,minWidth: 50},
        {header: "Frequency Days", isVisible: true, width: 95 ,minWidth: 50},
        {header: "LifeTime Max", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Patient Experience", isVisible: true, width: 123 ,minWidth: 50},
        {header: "Dosing Type", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Hepatic Impairement May Require Dose Adjustment", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Renal Impairement May Require Dose Adjustment", isVisible: true, width: 112 ,minWidth: 50}
    ];

    drugInsuRestListWJ = [
        {header: "Ins.Code", isVisible: true, width: 132 ,minWidth: 50},
        {header: "Ins.Name", isVisible: true, width: 156 ,minWidth: 50},
       // {header: "Billing NDC", isVisible: true, width: 162 ,minWidth: 50},
        // {header: "NDC Qualifier", isVisible: true, width: "3*" ,minWidth: 50},
        // {header: "Allowed", isVisible: true, width: "1*" ,minWidth: 50},
        // {header: "PA.?", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Max.Refills", isVisible: true, width: 112 ,minWidth: 50},
        {header: "MaxQty", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Apply to All Ins", isVisible: true, width: 122 ,minWidth: 50},
        {header: "Incentive Amount", isVisible: true, width: 181 ,minWidth: 50},
        {header: "Submission Clarification", isVisible: true, width: 210 ,minWidth: 50},
        {header: "Basis of Cost", isVisible: true, width: 158 ,minWidth: 50},
        {header: "DUR", isVisible: true, width: 246 ,minWidth: 50},
        {header: "Pharmacist Comment", isVisible: true, width: 247 ,minWidth: 50}

    ];

    drugInvVendorListWJ = [
        {header: "Vendor Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Account", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Vendor Item Code", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Unit Price Cost", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Cost Pack", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "AWP Pack", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Unit Price AWP", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Is Discountable?", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Last Updated", isVisible: true, width: "1.4*" ,minWidth: 50}
    ];

    drugInvHistoryListWJ = [
        {header: "Date Received", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Vendor Name", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Account", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Bucket", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Qty.Received", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Price", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Reference", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "PO#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Received By", isVisible: true, width: "1.2*" ,minWidth: 50},
       // {header: "NDC", isVisible: true, width: 125 ,minWidth: 50}
    ];

    mergePatientListWJ = [
        {header: "Rx#", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 38 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 38 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 316 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 95 ,minWidth: 50},
        {header: "SDays", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Auth#", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Status", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Patient Name", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Picked Up", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Copay", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Price", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: false, width: 112 ,minWidth: 50},
        {header: "NDC", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Due Days", isVisible: false, width: 112 ,minWidth: 50}
    ];

    profitRevDataSetListWJ = [
        {header: "Rx#-Ref#-Fill#", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 84 ,minWidth: 50},
        {header: "Ins", isVisible: true, width: 54 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 240 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 108 ,minWidth: 50},
        {header: "Qty.", isVisible: true, width: 76 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Cost Applied", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Drug Cost", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Rx Cost", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 180 ,minWidth: 50},
    ];

    easyRefillWizardListWJ = [
        {header: "Rx#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Refill Status", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Qty Disp", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "S.Days", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Ord Date", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "2*" ,minWidth: 50}
    ];

    rxByInsuPopupListWJ = [
        {header: "Ins.Code", isVisible: true, width: 148 ,minWidth: 50},
        {header: "Ins.Name", isVisible: true, width: 220 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 148 ,minWidth: 50},
        {header: "Processor Ctrl#", isVisible: true, width: 148 ,minWidth: 50},
        {header: "Pharmacy ID", isVisible: true, width: 148 ,minWidth: 50},
        {header: "Address", isVisible: true, width: 148 ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: 145 ,minWidth: 50}
    ];

    rxByInsuPayorPopupListWJ = [
        {header: "Payor Ins ID", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Payor Name", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Contact Name", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Zip", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "*" ,minWidth: 50}
    ];

    scheduledTaskListWJ = [
        {header: "Task", isVisible: true, width: "5*" ,minWidth: 50},
        {header: "Task Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Task Description", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Task Perform", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Start Date", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Start Time", isVisible: true, width: "0.8*" ,minWidth: 50},
        // {header: "Email", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Save File", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Enable", isVisible: true, width: "1*" ,minWidth: 50},
        // {header: "Email Address", isVisible: true, width: 290 ,minWidth: 50},
        {header: "Last Executed", isVisible: true, width: "1.9*" ,minWidth: 50}
    ];

    recallDeletedRxListWJ = [
        {header: "Rx#", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Deleted Date", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Deleted By", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Ins. type", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2.3*" ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Days", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "RPH", isVisible: true, width: "1.5*" ,minWidth: 50}
    ];

    drugPriceUpdateListWJ = [
        {header: "Date Updated", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "New Price", isVisibile: true, width: "1.2*" ,minWidth: 50},
        {header: "Old Price", isVisibile: true, width: "1.2*" ,minWidth: 50},
        {header: "Type", isVisibile: true, width: "1.2*" ,minWidth: 50},
        {header: "Manuf. Update Date", isVisibile: true, width: "1.2*" ,minWidth: 50},
        {header: "Updated By", isVisibile: true, width: "1.2*" ,minWidth: 50}
    ];

    erxChangeReqDURListWJ = [
        {header: "Reason of Service", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Professional Service", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Result of Service", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Level", isVisible: true, width: 68 ,minWidth: 50},
        {header: "ID Q", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Agent ID", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Clinical Signif.Code", isVisible: true, width: 68 ,minWidth: 50},
        {header:  "PH-Comment", isVisible: true, width: 67 ,minWidth: 50}
    ];

    erxChangeReqSelectDrugListWJ = [
        {header: "Drug Name", isVisible: true, width: 191 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Refills", isVisible: true, width: 64 ,minWidth: 50},
        {header: "DAW", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Sig", isVisible: true, width: 190 ,minWidth: 50},
    ];

    primeescPatAckListWJ = [
        {header: "Trans#", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Date", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Accept", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Sig Type", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Binary Sign", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Event Type", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Sign", isVisible: true, width: 231 ,minWidth: 50}
    ];

    primeescPatHistListWJ = [
        {header: "Date", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Insu", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Rxs Signed For", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Counseling", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Sig Type", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Manual Group no", isVisible: true, width: 114 ,minWidth: 50},
        {header: "PHARM", isVisible: true, width: 114 ,minWidth: 50},
        {header: "INSMSGACCEPTANCE", isVisible: true, width: 114 ,minWidth: 50},
        {header: "PHARMSIGDATA", isVisible: true, width: 114 ,minWidth: 50},
        {header: "INSSIGDATA", isVisible: true, width: 114 ,minWidth: 50},
        {header: "PHARMSIGBIN", isVisible: true, width: 114 ,minWidth: 50},
        {header: "INSSIGBIN", isVisible: true, width: 114 ,minWidth: 50},
        {header: "DelType", isVisible: true, width: 114 ,minWidth: 50},
        {header: "UserInitial", isVisible: true, width: 117 ,minWidth: 50},
    ];

    primeescSignByDateListWJ = [
        {header: "Patient Name", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Rxs Signed For", isVisible: true, width: "4*" ,minWidth: 50},
        {header: "Couns?", isVisible: true, width: "2*" ,minWidth: 50}
    ];

    primeescSignByRxAcknListWJ = [
        {header: "Trans#", isVisible: true, width: 400 ,minWidth: 50},
        {header: "Date", isVisible: true, width: 400 ,minWidth: 50},
        {header: "Accept", isVisible: true, width: 400 ,minWidth: 50},
        {header: "Event Type", isVisible: true, width: 399 ,minWidth: 50}
    ];

    primeescSignByRxHistListWJ = [
        {header: "Rx#", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Ins", isVisible: true, width: 267 ,minWidth: 50},
        {header: "Couns?", isVisible: true, width: 264 ,minWidth: 50}
    ];

    primeescRxPickUpDetInsuWJ = [
        {header: "Ins.Code", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Ins.Name", isVisible: true, width: 435 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Processor Ctrl#", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Pharmacy ID", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Address", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: 112 ,minWidth: 50}
    ];

    printRxWithAttDocsListWJ = [
        {header: "Rx#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Ins Code", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2.9*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Document ID", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Subcategory", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Title", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Scan Date", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    printRxWithAttDocsListWJFill = [
        {header: "Rx#", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 105 ,minWidth: 50},
        { header: "Fill#", isVisible: true, width: 167  ,minWidth: 50},
        {header: "Ins Code", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 290 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Subcategory", isVisible: true, width: 181 ,minWidth: 50},
        {header: "Title", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Scan Date", isVisible: true, width: 105 ,minWidth: 50}
    ];

    drugCounsellingWarningListWJ = [
        {header: "Warning", isVisible: true, width: "2.9*" ,minWidth: 50},
        {header: "Gender", isVisible: true, width: "2.4*" ,minWidth: 50},
        {header: "Age Start", isVisible: true, width: "2.9*" ,minWidth: 50},
        {header: "Age End", isVisible: true, width: "2.9*" ,minWidth: 50},
        {header: "Warn_Desc1", isVisible: true, width: "2.9*" ,minWidth: 50},
        {header: "Warn_Desc2", isVisible: true, width: "2.9*" ,minWidth: 50}
    ];

    drugPriceCheckHistListWJ = [
        {header: "Date", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Qty", isVisibe: true, width: "1*" ,minWidth: 50},
        {header: "Price", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    drugPriceCheckSimilarDrugListWJ = [
        {header: "Drug Name", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Dg.Mfg", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Pack Size", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Amount", isVisible: true, width: "1.5*" ,minWidth: 50}
    ];

    drugPriceCheckTotalListWJ = [
        {header: "Drug Name", isVisible: true, width: "2.5*" ,minWidth: 50},
        // {header: "Strength", isVisible: true, width: 232 ,minWidth: 50},
        // {header: "Form", isVisible: true, width: 175 ,minWidth: 50},
        {header: "Tot.Amt", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "PriceSchedule Name", isVisible: true, width: "1.7*" ,minWidth: 50}
    ];

    scheduledTaskExecHistListWJ = [
        {header: "Task Name", isVisible: true, width: "3.6*" ,minWidth: 50},
        {header: "Task Status", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Start Date", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Start Time", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "End Time", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Job Run Type", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Log Description", isVisible: true, width: "5*" ,minWidth: 50}
    ];
    revHistoryListWj = [
        { header: "Rx#", isVisible: true, width: "0.2*"  ,minWidth: 50},
        { header: "Ref#", isVisible: true, width: "0.1*"  ,minWidth: 50},
        { header: "Fill#", isVisible: true, width: "0.1*"  ,minWidth: 50},
        { header: "User Initial", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Date Time Verified", isVisible: true, width: "0.4*"  ,minWidth: 50},
        { header: "Bottle NDC", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Result", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Lot#", isVisible: true, width: "0.2*"  ,minWidth: 50},
        { header: "Expiration Date", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "GTIN#", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Serial#", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Run Date Time", isVisible: true, width: "0.3*"  ,minWidth: 50},
        { header: "Verified Quantity", isVisible: true, width: "0.3*"  ,minWidth: 50}
    ];
    otherInsuListWj = [
        {header: "Other Insurance", isVisible: true, width: 496 ,minWidth: 50},
        {header: "Payer Id", isVisible: true, width: 563 ,minWidth: 50},
        {header: "Qualifier", isVisible: true, width: 523 ,minWidth: 50},
    ];

    vendorInvHistListWJ = [
        {header: "Date Received", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 118 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Made by", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Vendor", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Account", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Qty. Received", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Unit price", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Pkgs. Received", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Reference", isVisible: true, width: 118 ,minWidth: 50},
        {header: "PO#", isVisible: true, width: 116 ,minWidth: 50}
    ];
    bucketLogListWJ = [
        {header: "Bucket Code", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: 186 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 300 ,minWidth: 50},
        {header: "Transaction Quantity", isVisible: true, width: 186 ,minWidth: 50},
        {header: "Transaction Date", isVisible: true, width: 160 ,minWidth: 50},
        {header: "Transaction Type", isVisible: true, width: 186 ,minWidth: 50},
        {header: "Transaction Name", isVisible: true, width: 186 ,minWidth: 50},
        {header: "Quantity In Hand", isVisible: true, width: 186 ,minWidth: 50},
    ];

    eRxExtraInfoListWJ = [
        {header: "Ins. Code", isVisible: true, width: 127 ,minWidth: 50},
        {header: "Payer Identification", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Payer Name", isVisible: true, width: 100 ,minWidth: 50},
        {header: "PCN", isVisible: false, width: 112 ,minWidth: 50},
        {header: "IIN/BIN", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Ins. ID", isVisible: true, width: 83 ,minWidth: 50},
        {header: "Card Holder ID", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Card Holder First Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Card Holder Last Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Card Holder Suffix", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Card Holder Prefix", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Group Id", isVisible: false, width: 100 ,minWidth: 50},
        {header: "Payer Type", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Group Name", isVisible: false, width: 112 ,minWidth: 50},

    ];

    rphVeryHistListWJ = [
        {header: "Rx#", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Verified By", isVisible: true, width: 300 ,minWidth: 50},
        {header: "Date Time Verified", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 269 ,minWidth: 50}
    ];

    drugMMSSearchList = [
        {header: "Drug Name", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 112 ,minWidth: 50},
      //  {header: "Bill NDC", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Made By", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Drug Type", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Strength", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Drug Form", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Units", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Brand", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Size", isVisible: true, width: 112 ,minWidth: 50},
        {header: "AWP Price", isVisible: true, width: 112 ,minWidth: 50},
        {header: "DIR Price", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Cost Price", isVisible: true, width: 112 ,minWidth: 50},
        {header: "FDA Approved", isVisible: true, width: 112 ,minWidth: 50},
    ];
    viewDatSetWj = [
        {header: "Drug Name", isVisible: true, width: 247 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 126 ,minWidth: 50},
        {header: "Pkg Size", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Mfg", isVisible: true, width: 227 ,minWidth: 50},
        {header: "Class", isVisible: true, width: 73 ,minWidth: 50},
        {header: "AWP", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Cost", isVisible: true, width: 143 ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Value(AWP)", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Value(Cost)", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Target Qty", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Recorder Level", isVisible: false, width: 112 ,minWidth: 50},
        {header: "Qty on Hand", isVisible: false, width: 112 ,minWidth: 50}
    ];
    InventoryTransactionAudit = [
        {header: "Trans. Type", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Transaction Date", isVisible: true, width: 219  ,minWidth: 50},
        {header: "Referenece", isVisible: true, width: 205 ,minWidth: 50},
        {header: "Bucket", isVisible: true, width: 280 ,minWidth: 50},
        {header: "Trans Qty", isVisible: true, width: 138 ,minWidth: 50},
    ];
    refillQueueWJ  = [
        {header: "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 100  ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 80 ,minWidth: 50},
        {header: "S.Days", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Date Ord", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 164 ,minWidth: 50},
        {header: "Refill Status", isVisible: true, width: 107 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 211 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 162 ,minWidth: 50},
    ];
    insuranceListWJ  = [
        {header: "Ins Code", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: 220 ,minWidth: 50},
        {header: "Insurance ID#", isVisible: true, width: 220 ,minWidth: 50},
        {header: "Bill Order", isVisible: true, width: 97 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 200 ,minWidth: 50},
        {header: "PCN", isVisible: true, width: 200 ,minWidth: 50},
    ];
    reviewRxHistwj = [
        {header: "Rx#", isVisible: true, width: 168 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 184 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 172 ,minWidth: 50},
        {header: "Old Tag Name", isVisible: true, width: 166 ,minWidth: 50},
        {header: "New Tag Name", isVisible: true, width: 162 ,minWidth: 50},
        {header: "Modified By", isVisible: true, width: 152 ,minWidth: 50},
        {header: "Modified Date Time", isVisible: true, width: 165 ,minWidth: 50}
    ];
    primeEDIPriceUpdateHistListWJ = [
        {header: "File ID", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Last Updated Date", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Records", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Drugs Updated", isVisible: true, width: "3*" ,minWidth: 50},
        {header: "Vendor Name", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Account", isVisible: true, width: "2.5*" ,minWidth: 50},
    ];
    BenefitCheckCoverageInfoQueueWj = [
        {header: "Drug Type", isVisible: true, width: 230 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 277 ,minWidth: 50},
        {header: "30 Days", isVisible: true, width: 250 ,minWidth: 50},
        {header: "45 Days", isVisible: true, width: 210 ,minWidth: 50},
        {header: "90 Days", isVisible: true, width: 210 ,minWidth: 50},
        {header: "PA Req?", isVisible: true, width: 100 ,minWidth: 50}
    ];
    refillFlowComponent = [
        {header: "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 50  ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 70 ,minWidth: 50},
        {header: "NDC",isVisible : true, width: 100 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 220 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 65 ,minWidth: 50},
        {header: "Prescriber", isVisible: true, width: 200 ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: 50 ,minWidth: 50},
    ];
    drugOtherPriceswj = [
        {header: "Price Type", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Unit Price", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Updated By", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Last Updated Date Time", isVisible: true, width: "*" ,minWidth: 50}
    ];
    fileRecordsWJ = [
        {header: "Fill#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Total Qty Disp.", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Qty Disp.", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Total Rx Qty Rem", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Days", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Ingr. Cost", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Ingredient Cost", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Dispensing Fee", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Usual and Custom", isVisible: true, width: "2.2*" ,minWidth: 50}
    ]
    cntrlSettingsWj = [
        {header: "State", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Version", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "File Type", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Gen. Control File By", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "IsActive?", isVisible: true, width: "1*" ,minWidth: 50}
    ]
    insuranceToBillWj = [
        {header: "Ins Code", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: 480 ,minWidth: 50},
        {header: "Insurance#", isVisible: true, width: 155 ,minWidth: 50},
        {header: "Bill Order", isVisible: true, width: 150 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 90 ,minWidth: 50},
        {header: "PCN", isVisible: true, width: 90 ,minWidth: 50}
    ]
    patientSpecificWj = [
        {header: "Last Name", isVisible: true, width: 230 ,minWidth: 50},
        {header: "First Name", isVisible: true, width: 230 ,minWidth: 50},
        {header: "License#", isVisible: true, width: 110 ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Address", isVisible: true, width: 335 ,minWidth: 50}
    ]
    patientMedAdherenceWj = [
        {header: "Patient Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Age", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Category Code", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Facility", isVisible: true, width: 140 ,minWidth: 50}
    ]
    equivalentDrugWj = [
        {header: "Drug Name", isVisible: true, width: 214 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 98 ,minWidth: 50},
        {header: "Dg. Mfg", isVisible: true, width: 104 ,minWidth: 50},
        {header: "Branded", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Pkg. Size", isVisible: true, width: 70 ,minWidth: 50},
        {header: "AWP", isVisible: true, width: 52 ,minWidth: 50},
        {header: "Inventory", isVisible: true, width: 81 ,minWidth: 50},
        {header: "Inv. In Hand", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Check Qty", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Last Dispensed Date", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Preferred", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: 160 ,minWidth: 50},
        {header: "Specfic Product Id", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Therapeutic", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Unit Price Cost", isVisible: true, width: 62 ,minWidth: 50},
        {header: "Last Vendor", isVisible: true, width: 70 ,minWidth: 50},
    ]
    rxTransmissionLogWJ = [
        {header: "Rx#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Result", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Transm. Date", isVisible: true, width: 190 ,minWidth: 50},
        {header: "Ins. Code", isVisible: true, width: 130 ,minWidth: 50},
        {header: "Trans.", isVisible: true, width: 70 ,minWidth: 50},
        {header: "User", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 120 ,minWidth: 50}
    ]
    printRefReqWJ = [
        {header: "From Name", isVisible: true, width: 275 ,minWidth: 50},
        {header: "To Name", isVisible: true, width: 275 ,minWidth: 50},
        {header: "To Fax#", isVisible: true, width: 185 ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: 115 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Rx Origin", isVisible: true, width: 150 ,minWidth: 50}
    ]
    printbatchedRxsRefReqWJ = [
        {header: "From Name", isVisible: true, width: 275 ,minWidth: 50},
        {header: "To Name", isVisible: true, width: 275 ,minWidth: 50},
        {header: "To Fax#", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 65 ,minWidth: 50},
        {header: "Fax Date", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Time Info", isVisible: true, width: 90 ,minWidth: 50}
    ]
    quickRefillWJ = [
        {header: "Refill Status", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Qty Disp", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Price", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Copay", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "2*" ,minWidth: 50},

    ]
    faxbatchedRxsRefReqWJ = [
        {header: "From Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "To Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "To Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Fax Date", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Time Info", isVisible: true, width: "0.9*" ,minWidth: 50}
    ]
    faxRefReqWJ = [
        {header: "From Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "To Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "To Fax#", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Rx Origin", isVisible: true, width: "1*" ,minWidth: 50}
    ]

    controlResubmitListWJ = [
        {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 87 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Date Ordered", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 145 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: 100 ,minWidth: 50}
    ];

    controlgenerateListWJ = [
        {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 87 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 59 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Date Ordered", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 56 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 174 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 125 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: 110 ,minWidth: 50}
    ];

    rxBasicDisplayListWJ = [
        {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 87 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: 101 ,minWidth: 50},
        {header: "Date Ordered", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 174 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 127 ,minWidth: 50},
        {header: "Pickup Date", isVisible: true, width: 100 ,minWidth: 50}
    ];
    labelQueueDisplayListWJ = [
        {header: "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 40 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Date Queued", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Queued By", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 131 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 55 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Copay", isVisible: true, width: 96 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Print Count from Queue", isVisible: true, width: 101 ,minWidth: 50},
        {header: "Printed Previously?", isVisible: true, width: 101 ,minWidth: 50},
        {header: "Sig", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Notes", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Delivery", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Facility CD", isVisible: true, width: 86 ,minWidth: 50},
        {header: "Patient Address", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Patient Phone", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Patient Email", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Order Date", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Patient Mobile", isVisible: true, width: 131 ,minWidth: 50},
        {header: "Patient Insurance", isVisible: true, width: 130 ,minWidth: 50},
        {header: "Del Status", isVisible: true, width: 92 ,minWidth: 50},
        {header: "Ins", isVisible: false, width: 120 ,minWidth: 50},
        {header: "Full Address", isVisible: false, width: 120 ,minWidth: 50},
        {header: "Time In Queue", isVisible: false, width: 113 ,minWidth: 50},
        {header: "Printed From Queue?", isVisible: false, width: 148 ,minWidth: 50},
        {header: "Nrefill", isVisible: false, width: 64 ,minWidth: 50},
        {header: "Lot#", isVisible: false, width: 140 ,minWidth: 50},
        {header: "Drug Expiration Date", isVisible: false, width: 166 ,minWidth: 50}
    ];
    topPerfomersPatientListWj = [
        {header: "Patient Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 60},
        {header: "Rx Count", isVisible: true, width: "0.5*" ,minWidth: 40},
        {header: "Refill Count", isVisible: true, width: "0.5*" ,minWidth: 40},
        {header: "Fill Count", isVisible: true, width: "0.5*" ,minWidth: 40},
        {header: "Total Rx Amount", isVisible: true, width: "1*" ,minWidth: 40},
        {header: "Total Copay", isVisible: true, width: "1*" ,minWidth: 40},
        {header: "Total Cost", isVisible: true, width: "1*" ,minWidth: 40},
        {header: "Profit/Loss", isVisible: true, width: "1*" ,minWidth: 40},
    ];
    topPerfomersInsideListWj = [
        {header: "Rx#", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: "1.4*" ,minWidth: 50},
    ];
    topPerfomersPrescriberListWj = [
        {header: "Prescriber Name", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "PresLNm", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "PresFNm", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "PresType", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Rx Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Refill Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Fill Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Copay", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: "0.8*" ,minWidth: 50},
    ];
    topPerfomersDrugListWj = [
        {header: "Drug Name", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Form", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Strength", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Total Qty", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Qty In Stock", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Avg/Month", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Rx Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Refill Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Fill Count", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Copay", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: "1*" ,minWidth: 50},
    ];
    topPerfomersInsListWj = [
        {header: "Insurance Code", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Insurance Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Rx Count", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Refill Count", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Fill Count", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Total Copay", isVisible: true, width: "2.1*" ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: "1.7*" ,minWidth: 50},
    ];
    topPerfomersFacListWj = [
        {header: "Facility Code", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Facility Name", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Rx Count", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Refill Count", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Fill Count", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Total Copay", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Profit/Loss", isVisible: true, width: "0.8*" ,minWidth: 50},
    ];
    forGroupViewWj = [
        {header: "Patient Name", isVisible: true, width: 388 ,minWidth: 50},
        {header: "Patient Phone", isVisible: true, width: 339 ,minWidth: 50},
        {header: "Patient Mobile", isVisible: true, width: 387 ,minWidth: 50},
        {header: "Delivery", isVisible: true, width: 481 ,minWidth: 50},

    ];
    CntrlRxAuditTrailWj = [
        {header: "Rx#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Entered By", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Changed By", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Field Change", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Original Value", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "New Value", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Changed Date", isVisible: true, width: "1.4*" ,minWidth: 50},
    ];
    automatSubWj = [
        {header: "State", isVisible: true, width: 324 ,minWidth: 50},
        {header: "File WebSite", isVisible: true, width: 934 ,minWidth: 50},
        {header: "Upload file to FTP/SFTP?", isVisible: true, width: 304 ,minWidth: 50},
        // {header: "Send Email?", isVisible: true, width: 281 ,minWidth: 50},
    ];
    viewErrorCntrlRxWj = [
        {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Control Error", isVisible: true, width: 250 ,minWidth: 50},
        {header: "Amount", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Billed", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Insu Paid", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Copay", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 126 ,minWidth: 50},
        {header: "Date Ordered", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Ins.", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: 60 ,minWidth: 50},
        {header: "Days", isVisible: true, width: 70 ,minWidth: 50},
    ];
    logicalAccessCtrlWj = [
        {header: "Changed By", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Changed For", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Document", isVisible: true, width: "5.3*" ,minWidth: 50},
        {header: "Function", isVisible: true, width: "3.9*" ,minWidth: 50},
        {header: "Change Date", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Old Permissions", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "New Permissions", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Operation", isVisible: true, width: "1.1*" ,minWidth: 50},
    ];
    messageLogWj = [
        {header: "Patient Name", isVisible: true, width: "2.3*" ,minWidth: 50},
        {header: "Mobile#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Date of Birth", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Message Type", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Message", isVisible: true, width: "3.2*" ,minWidth: 50},
        {header: "Sent/Received Date Time", isVisible: true, width: "1.9*" ,minWidth: 50},
        {header: "Message Status", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Exception Details", isVisible: true, width: "2.2*" ,minWidth: 50},
        {header: "Sent By", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Sent Method", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Notification Type", isVisible: true, width: "0.9*" ,minWidth: 50},
    ];
    messageQueueWj = [
        {header: "Patient Name", isVisible: true, width: "3.9*" ,minWidth: 50},
        {header: "Mobile#", isVisible: true, width: "2.2*" ,minWidth: 50},
        {header: "Message Type", isVisible: true, width: "2.8*" ,minWidth: 50},
        {header: "Message", isVisible: true, width: "3.6*" ,minWidth: 50},
        {header: "Message Queued Date Time", isVisible: true, width: "2.8*" ,minWidth: 50},
        {header: "Sent By", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Sent Method", isVisible: true, width: "2.3*" ,minWidth: 50}
    ];
    controlFileError = [
        {header: "Rx#", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Resolved Date", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Control Error", isVisible: true, width: 260 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 176 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 126 ,minWidth: 50},
        {header: "Amount", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Billed", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Insu Paid", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Copay", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Date Ordered", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Status", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Ins.", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Qty", isVisible: false, width: 60 ,minWidth: 50},
        {header: "Days", isVisible: false, width: 70 ,minWidth: 50},
    ];
    controlFileErrorForNY = [
        // {header: "Rx#", isVisible: true, width: 60 ,minWidth: 50},
        // {header: "Ref#", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Patient Name", isVisible: true, width: 170 ,minWidth: 50},
        // {header: "Drug Name", isVisible: true, width: 180 ,minWidth: 50},
        // {header: "NDC", isVisible: true, width: 126 ,minWidth: 50},
        // {header: "Prescriber Name", isVisible: true, width: 170 ,minWidth: 50},
        // {header: "Ins.", isVisible: true, width: 70 ,minWidth: 50},
        // {header: "Error Code", isVisible: true, width: 170 ,minWidth: 50},
        // {header: "Error Description", isVisible: true, width: 180 ,minWidth: 50},
        // {header: "Value Provided", isVisible: true, width: 126 ,minWidth: 50},
        // {header: "Comment", isVisible: true, width: 170 ,minWidth: 50},
        // {header: "Submitted Date", isVisible: true, width: 70 ,minWidth: 50},
        // {header: "Fill Date", isVisible: true, width: 70 ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Resolved Date", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Control Error", isVisible: true, width: 260 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 170 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 176 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 126 ,minWidth: 50},
        {header: "Amount", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Billed", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Insu Paid", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Copay", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Date Ordered", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Status", isVisible: false, width: 50 ,minWidth: 50},
        {header: "Ins.", isVisible: false, width: 70 ,minWidth: 50},
        {header: "Qty", isVisible: false, width: 60 ,minWidth: 50},
        {header: "Days", isVisible: false, width: 70 ,minWidth: 50},
    ];
    submissionLog = [
        {header: "State", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Submission Type", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Submission DtTm", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "No. Of Rx(s)", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Report Status", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Submission Status", isVisible: true, width: "0.8*" ,minWidth: 50},
    ]

    refillDueMsgOuterWj = [
        // {header: "patientNo", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 217 ,minWidth: 50},
        {header: "Language", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Email", isVisible: true, width: 228 ,minWidth: 50},
        {header: "Date of Birth", isVisible: true, width: 98 ,minWidth: 50},
        // {header: "Phone#", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Mobile#", isVisible: true, width: 115 ,minWidth: 50},
        // {header: "Sms Carrier", isVisible: true, width: 141 ,minWidth: 50},
         {header: "Gender", isVisible: true, width: 66 ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: 132 ,minWidth: 50},
        {header: "Patient Address", isVisible: true, width: 324 ,minWidth: 50},
        {header: "Is Not Pickup Remainder", isVisible: true, width: 166 ,minWidth: 50},
        // {header: "Is Not Pickup SMS", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Is send Del Ship Batch Message", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Is send Del Ship Batch Email", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Is send Del Ship Batch Phone call", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Is send Del Ship Batch SMS", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Send Pickup Remainder when Billed", isVisible: true, width: 50 ,minWidth: 50},
        // {header: "Allowed for Facility", isVisible: true, width: 50 ,minWidth: 50},
    ];
    refillDueMsgInnerWj = [
        // {header: "patientNo", isVisible: true, width: 141 ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 53 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Refill Reminder Sent?", isVisible: true, width: 167 ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: 89 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 243 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 129 ,minWidth: 50},
        {header: "IsActive?", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 167 ,minWidth: 50},
        {header: "Primary Insurance", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Pickup Due Date", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Total Ins Paid", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Profit", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Rx Type", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Delivery Method", isVisible: false, width: 74 ,minWidth: 50},
    ];
    refillDueMsgIndividualWj = [
        {header: "Rx#", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 64 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 53 ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Refill Reminder Sent?", isVisible: true, width: 167 ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: 89 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 243 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 129 ,minWidth: 50},
        {header: "IsActive?", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 167 ,minWidth: 50},
        {header: "Primary Insurance", isVisible: true, width: 140 ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Total Rx Amount", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Date of Birth", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Mobile#", isVisible: true, width: 74 ,minWidth: 50},
        {header: "Pickup Due Date", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Total Ins Paid", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Profit", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Rx Type", isVisible: false, width: 74 ,minWidth: 50},
        {header: "Delivery Method", isVisible: false, width: 74 ,minWidth: 50},
    ];
    geographyDistributionWj = [
        {header:  "Zip", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Patient#", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "%Patients", isVisible: true, width: "0.8*" ,minWidth: 50},
    ];
    drugThearpauticWj = [
        {header:  "Concept", isVisible: true, width: "2.5*" ,minWidth: 50},
        {header: "Drug#", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.6*" ,minWidth: 50}
    ];
    reverseClaim = [
        {header:  "Rx#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 45 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 45 ,minWidth: 50},
        {header: "Rec Type", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Cov", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Ins.Code", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Date", isVisible: true, width: 100 ,minWidth: 50},
        {header: "OTHPYRPDQ", isVisible: true, width: 175 ,minWidth: 50},
        {header: "Ingr.Cost Paid", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Fee Paid", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Pat Pay", isVisible: true, width: 100 ,minWidth: 50},
        {header: "FSTAXAMT", isVisible: true, width: 100 ,minWidth: 50},
        {header: "PSTAXAMT", isVisible: false, width: 100 ,minWidth: 50},
        {header: "PSTAXRATE", isVisible: false, width: 100 ,minWidth: 50},
        {header: "INCAMTPAID", isVisible: false, width: 100 ,minWidth: 50},
        {header: "PSFEEPAID", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHAMTPAID", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OthPayRecog.", isVisible: false, width: 100 ,minWidth: 50},
        {header: "NetPaid", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYQ1", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYAMT1", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYQ2", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYAMT2", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYQ3", isVisible: false, width: 100 ,minWidth: 50},
        {header: "OTHPAYAMT3", isVisible: false, width: 100 ,minWidth: 50},
        {header: "TAXEXEMPT", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BASISOFREI", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BOC_DFEE", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BOC_COPAY", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BOC_FSTAX", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BOC_PSTAX", isVisible: false, width: 100 ,minWidth: 50},
        {header: "REJCODES", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AMT_PREDED", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AMT_SALETX", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AMT_COPINS", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AMT_PRODSL", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AMT_EXCMAX", isVisible: false, width: 100 ,minWidth: 50},
        {header: "INSNETPAID", isVisible: false, width: 100 ,minWidth: 50},
        {header: "PSTaxBasisPaid", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AccumDedAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "RemDedAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "RemBenefitAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtProcFee", isVisible: false, width: 100 ,minWidth: 50},
        {header: "PatSTaxAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtCoIns", isVisible: false, width: 100 ,minWidth: 50},
        {header: "BOC_CoIns", isVisible: false, width: 100 ,minWidth: 50},
        {header: "EstGen", isVisible: false, width: 100 ,minWidth: 50},
        {header: "SpendAccAmtRem", isVisible: false, width: 100 ,minWidth: 50},
        {header: "HPIanFundAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "SpendAccAmtRem", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtProdSelBrand", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtProvNetSel", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtProdSelNPForm", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtProdSelNPFormB", isVisible: false, width: 100 ,minWidth: 50},
        {header: "AmtCovGap", isVisible: false, width: 100 ,minWidth: 50},
        {header: "IngCostContRAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "DFeeContRAmt", isVisible: false, width: 100 ,minWidth: 50},
        {header: "COBBillSeq", isVisible: false, width: 100 ,minWidth: 50},
        {header: "InsNetPaid", isVisible: false, width: 100 ,minWidth: 50},
        {header: "MFP/SDRA", isVisible: false, width: 100 ,minWidth: 50}
    ];
    inventoryListwj = [
        {header: "Bucket Name", isVisible: false, width: 144 ,minWidth: 50},
        {header: "Qty", isVisible: false, width: 127 ,minWidth: 50},
        {header: "Bucket Type", isVisible: false, width: 203 ,minWidth: 50},
        {header: "Last Vendor", isVisible: false, width: 100 ,minWidth: 50},
        {header: "Cost", isVisible: false, width: 83 ,minWidth: 50},
        {header: "Last Received Date", isVisible: false, width: 173 ,minWidth: 50},
        {header: "Qty On Order", isVisible: false, width: 100 ,minWidth: 50}
    ];
    insuaranceListeRxListwj = [
        {header: "IsPrimary", isVisible: true, width: 144 ,minWidth: 50},
        {header: "Ins. Code", isVisible: true, width: 127 ,minWidth: 50},
        {header: "PCN", isVisible: true, width: 203 ,minWidth: 50},
        {header: "BIN", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Ins. ID", isVisible: true, width: 83 ,minWidth: 50},
        {header: "Group#", isVisible: true, width: 173 ,minWidth: 50},
        {header: "C.H. First Name", isVisible: true, width: 100 ,minWidth: 50},
        {header: "C.H. Last Name", isVisible: true, width: 100 ,minWidth: 50},
        {header: "C.H. DOB", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Relation", isVisible: true, width: 100 ,minWidth: 50}
    ];
    insuExceptionListWJ=[
        {header: "Rx#", isVisible: true, width: 92 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 47 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 47 ,minWidth: 50},
        {header: "Date Filled", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Ins Type", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Patient", isVisible: true, width: 144 ,minWidth: 50},
        {header: "Drug", isVisible: true, width: 240 ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: 114 ,minWidth: 50},
        {header: "Qty", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Cost", isVisible: true, width: 85 ,minWidth: 50},
        {header: "Amt Billed", isVisible: false, width: 85 ,minWidth: 50},
        {header: "Ins Paid", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Pat Paid", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Total Paid", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Profit", isVisible: false, width: 90 ,minWidth: 50},
        {header: "Bin#", isVisible: false, width: 90 ,minWidth: 50},
        {header: "P.Ctrl#", isVisible: false, width: 90 ,minWidth: 50},
     ];
     physicalInvStatusRecWJ = [
        {header: "Bucket", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Manage Inventory", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "View Records", isVisible: true, width: "1.6*" ,minWidth: 50},
     ];
     physicalInvRecWJ = [
        {header: "Date of Entry", isVisible: true, width: 234 ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: 229 ,minWidth: 50},
        {header: "Total Qty", isVisible: true, width: 154 ,minWidth: 50},
        {header: "Packs", isVisible: true, width: 247 ,minWidth: 50},
        {header: "Loose Qty", isVisible: true, width: 306 ,minWidth: 50},
     ];
     labelDesignListWJ = [
        {header: "System Template", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Name", isVisible: true, width: "4.5*" ,minWidth: 50},
        {header: "Page Size", isVisible: true, width: "3.8*" ,minWidth: 50},
        {header: "Created", isVisible: true, width: "2.8*" ,minWidth: 50},
        {header: "Modified", isVisible: true, width: "2.8*" ,minWidth: 50},
     ];
     compoundIngListWJ = [
        {header: "DRUG NAME", isVisible: true, width: 409 ,minWidth: 50},
        {header: "NDC", isVisible: true, width: 138 ,minWidth: 50},
        {header: "QUANTITY", isVisible: true, width: 88 ,minWidth: 50},
        {header: "AWP", isVisible: true, width: 88 ,minWidth: 50},
        {header: "Price", isVisible: true, width: 100 ,minWidth: 50},
        {header: "LOT#", isVisible: true, width: 97 ,minWidth: 50},
        {header: "EXP DATE", isVisible: true, width: 88 ,minWidth: 50},
        {header: "INGR. PROP%", isVisible: true, width: 105 ,minWidth: 50},
        {header: "COST", isVisible: true, width: 100 ,minWidth: 50},
        {header: "ACTIVE", isVisible: true, width: 88 ,minWidth: 50},
        {header: "Qty Sufficient", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Optional", isVisible: true, width: 100 ,minWidth: 50},
        {header: "MOD.1", isVisible: false, width: 56 ,minWidth: 50},
        {header: "MOD.2", isVisible: false, width: 56 ,minWidth: 50},
        {header: "MOD.3", isVisible: false, width: 56 ,minWidth: 50},
        {header: "BASIS", isVisible: false, width: 100 ,minWidth: 50}
     ];
     prescriberSearchWJ=
     [
        {header: "LAST NAME",isVisible: true, width:190 ,minWidth: 50},
        {header:"FIRST NAME",isVisible: true, width:190 ,minWidth: 50},
        {header: "NPI#",isVisible: true, width:50 ,minWidth: 50},
        {header:"PHONE#",isVisible: true, width:50 ,minWidth: 50},
        {header:"FAX#",isVisible: true, width:50 ,minWidth: 50},
        {header: "STREET",isVisible: true, width:220 ,minWidth: 50},
        {header:"STATE",isVisible: true, width:50 ,minWidth: 50},
        {header:"CITY",isVisible: true, width:50 ,minWidth: 50},
        {header:"ZIP",isVisible: true, width:50 ,minWidth: 50},
        {header:"LICENSE#",isVisible: true, width:50 ,minWidth: 50},
        {header:"DEA#",isVisible: true, width:50 ,minWidth: 50},
        {header:"SPI#",isVisible: true, width:50 ,minWidth: 50},
        {header:"ACTIVE",isVisible: true, width:190 ,minWidth: 50},
        {header:"SERVICE LEVEL NAME",isVisible: true, width:220 ,minWidth: 50},
        {header:"SERVICE LEVEL",isVisible: true, width:190 ,minWidth: 50},
     ];
     InsuFileSearchWJ =
     [
        {header:"Ins.Code",isVisible:true, width:102 ,minWidth: 50},
        {header:"Ins.Name",isVisible:true, width:113 ,minWidth: 50},
        {header:"Address",isVisible:true, width:202 ,minWidth: 50},
        {header:"Phone#",isVisible:true, width:109 ,minWidth: 50},
        {header:"Pharmacy Id#",isVisible:true, width:101 ,minWidth: 50},
        {header:"Processor Ctrl",isVisible:true, width:112 ,minWidth: 50},
        {header:"Bin#",isVisible:true, width:50 ,minWidth: 50},
        {header:"Ver",isVisible:true, width:101 ,minWidth: 50},
        {header:"Comm.Method",isVisible:true, width:140 ,minWidth: 50},
        {header:"Notes",isVisible:true, width:142 ,minWidth: 50}
     ];
     DurValWj = [
        {header:"Reason of Service",isVisible:true, width:185 ,minWidth: 50},
        {header:"Professional Service",isVisible:true, width:412 ,minWidth: 50},
        {header:"Result of Service",isVisible:true, width:230 ,minWidth: 50},
        {header:"Level",isVisible:true, width:226 ,minWidth: 50},
        {header:"Id Q",isVisible:true, width:80 ,minWidth: 50},
        {header:"Agent Id",isVisible:true, width:80 ,minWidth: 50},
        {header:"Clinical Signif.Code",isVisible:true, width:203 ,minWidth: 50},
        {header:"PH-Comment",isVisible:true, width:211 ,minWidth: 50},
     ]
     manageInvwj = [
        {header:"Bucket",isVisible:true, width:"1.5*" ,minWidth: 50},
        {header:"Transaction Date",isVisible:true, width:"2*" ,minWidth: 50},
        {header:"User",isVisible:true, width:"1.5*" ,minWidth: 50},
        {header:"Status",isVisible:true, width:"1*" ,minWidth: 50},
     ];
     physicalInvWj =[
        {header:"Bucket",isVisible:true, width:"1.5*" ,minWidth: 50},
        {header:"Transaction Date",isVisible:true, width:"1.7*" ,minWidth: 50},
        {header:"Transaction Qty",isVisible:true, width:"1.6*" ,minWidth: 50},
        {header:"User",isVisible:true, width:"1*" ,minWidth: 50},
        {header:"Is Deleted?",isVisible:true, width:"1.6*" ,minWidth: 50},

     ];
     receiveInvWj = [
        {header:"Bucket",isVisible:true, width:"1.5*" ,minWidth: 50},
        {header:"Transaction Date",isVisible:true, width:"1.8*" ,minWidth: 50},
        {header:"User",isVisible:true, width:"1.5*" ,minWidth: 50},
        {header:"Transaction Qty",isVisible:true, width:"1.6*" ,minWidth: 50},
        {header:"Is Deleted?",isVisible:true, width:"1.6*" ,minWidth: 50},
     ];
     dispensedInvWj = [
        {header:"Bucket",isVisible:true, width:"1.4*" ,minWidth: 50},
        {header:"Transaction Date",isVisible:true, width:"1.8*" ,minWidth: 50},
        {header:"Reference Number",isVisible:true, width:"1.8*" ,minWidth: 50},
        {header:"User",isVisible:true, width:"1.2*" ,minWidth: 50},
        {header:"Transaction Qty",isVisible:true, width:"1.7*" ,minWidth: 50},
        {header:"Type",isVisible:true, width:"1.1*" ,minWidth: 50},
     ];

     DURValNewRxWJ = [
        {header: "Reason of Service", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Professional Service", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Result of Service", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Level", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Id Q", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Agent Id", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Clinical Signif.Code", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "PH-Comment", isVisible: true, width: "2*" ,minWidth: 50},
     ];
     NoteHistory = [
        {header: "Created Date & Time", isVisible: true, width: 162 ,minWidth: 50},
        {header: "Created By", isVisible: true, width: 115 ,minWidth: 50},
        {header: "Notes", isVisible: true, width: 367 ,minWidth: 50},
     ];
     prescClinicAddListPopupWJ = [
        {header: "SPI#", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Address1", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Address2", isVisible: true, width: "*" ,minWidth: 50},
        {header: "State", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "City", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "ZipCode", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Active", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Telephone#", isVisible: true, width: "1*" ,minWidth: 50},
    ];
    PrescTypeFileWJ = [
        {header: "Code", isVisible:true, width :'*' ,minWidth: 50},
        {header: "Description", isVisible:true, width :'2*' ,minWidth: 50}
    ];
    edi810SuccessfulRecords = [
        {header: "Invoice#", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Invoice Received Date", isVisible: true, width: 185 ,minWidth: 50},
        {header: "NDC#", isVisible: true, width: 152 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 253 ,minWidth: 50},
        {header: "Account", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Pack Size", isVisible: true, width: 81 ,minWidth: 50},
        {header: "Actual Qty", isVisible: true, width: 103 ,minWidth: 50},
        {header: "Units", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Cost Per Pack", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Unit Cost", isVisible: true, width: 95 ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Transaction Name", isVisible: true, width: 145 ,minWidth: 50},
        {header: "Item#", isVisible: true, width: 100 ,minWidth: 50},
        // {header: "Process Status", isVisible: true, width: 192 ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Expiration Date", isVisible: true, width: 154 ,minWidth: 110}
        
    ];
    edi810UnSuccessfulRecords = [
        {header: "Invoice#", isVisible: true, width: 94  ,minWidth: 50},
        {header: "Invoice Received Date", isVisible: true, width: 185 ,minWidth: 50},
        {header: "NDC#", isVisible: true, width: 110 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 222 ,minWidth: 50},
        {header: "Account", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Quantity", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Pack Size", isVisible: true, width: 81 ,minWidth: 50},
        {header: "Actual Qty", isVisible: true, width: 103 ,minWidth: 50},
        {header: "Physical Inv", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Units", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Cost Per Pack", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Unit Cost", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Pack AWP", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Unit AWP", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Total Cost", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Drug Exists?", isVisible: true, width: 80 ,minWidth: 50},
        {header: "Item#", isVisible: true, width: 49 ,minWidth: 50},
        {header: "Process Status", isVisible: true, width: 192 ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: 79 ,minWidth: 50},
        {header: "Expiration Date", isVisible: true, width: 135 ,minWidth: 50}
    ];

    refReqPrescriberWj = [
        {header: "Last Name", isVisible: true, width: 192 ,minWidth: 50},
        {header: "First Name", isVisible: true, width: 192 ,minWidth: 50},
        {header: "Address", isVisible: true, width: 383 ,minWidth: 50},
        {header: "Fax#", isVisible: true, width: 105 ,minWidth: 50},
        {header: "Telephone#", isVisible: true, width: 105 ,minWidth: 50},
        {header: "License#", isVisible: true, width: 124 ,minWidth: 50},
        {header: "DEA#", isVisible: true, width: 89 ,minWidth: 50},
    ];
    drugCatoriesList = [
        {header: "Category ID", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Category Name", isVisible: true, width: "2*" ,minWidth: 50}
    ];
    intakeQueueWjList = [
        {header: "Type", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Auth#", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Status", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Date", isVisible: true, width: "0.6*" ,minWidth: 50},
        {header: "Insurance", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Supply Days", isVisible: true, width: "0.5*" ,minWidth: 50},
        // {header: "Date Ordered", isVisible: true, width: 130 ,minWidth: 50},
        {header: "Facility", isVisible: true, width: "0.7*" ,minWidth: 50},
    ];
    fileGeneratorList = [
        {header: "Patient Name", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Date Of Birth", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Gender", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Address", isVisible: true, width: "2*" ,minWidth: 50}
    ];
    fileGeneratorRxList = [
        {header: "Rx#", isVisible: true, width: 125 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 75 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true ,  width: 75 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 163 ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: 250 ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: 100 ,minWidth: 50},
        {header: "Sig Code", isVisible: true, width: 150 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 250 ,minWidth: 50},
        {header: "HOA", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Sent To Packaging?", isVisible: true, width: 175 ,minWidth: 50},
    ];
    iouWjList = [
        {header : "NDC#", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width:  "0.5*" ,minWidth: 50},
        {header: "Actual Qty Disp", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Qty. Owed", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "DPV Date & Time", isVisible: true, width: "0.4*" ,minWidth: 50},
        // {header: "Notes/Comments", isVisible: true, width: 299 ,minWidth: 50},
        // {header: "Source", isVisible: true, width: 131 ,minWidth: 50}
    ];
    DPVVerfListWJ = [
        {header: "Drug NDC", isVisible: true, width: "0.35*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "0.5*" ,minWidth: 50},
        // {header: "Manufacturer", isVisible: true, width: 165 ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Actual Qty Disp", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Lot#", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Expiration Date", isVisible: true, width: "0.4*" ,minWidth: 110}
    ];
    NoteCatoriesList = [
        {header: "Category Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "System Default Subcategory", isVisible: true, width: "0.4*" ,minWidth: 50},
        {header: "Subcategory Name", isVisible: true, width: "1.3*" ,minWidth: 50}
        
    ];

    InvReconRepWj = [
        {header: "NDC", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Bucket Name", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "Initials", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "Date of Last Inv", isVisible: true, width: "0.43*" ,minWidth: 50},
        {header: "#Starting Qty of Last Inv", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "+Purchases (since last Inv)", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "-Dispensed (since last Inv)", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "+Return to Stock", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "=Inv# as of (To Date value that is selected on filters)", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Current Actual on Hand Inv", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Discrepancy", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Reason & Corrective Action", isVisible: true, width: "1*" ,minWidth: 50}
    ];

    InvRecnSubWj = [
        {header: "Transaction Type", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "Rx#", isVisible: true, width: "0.1*" ,minWidth: 50},
        {header: "Date and Time", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "0.1*" ,minWidth: 50},
        {header: "Periodic Inv Count", isVisible: true, width: "0.2*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "0.3*" ,minWidth: 50},
        {header: "Initials", isVisible: true, width: "0.1*" ,minWidth: 50},
        {header: "Comments", isVisible: true, width: "0.4*" ,minWidth: 50}
    ]

    vaccnImmunGeneratorListWJ = [
        {header: "Rx#-Ref#-Fill#", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Fill Date & Time", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Completion Status", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Vaccine Group", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "File Submitted DtTm", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Submitted Status", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Error Details", isVisible: true, width: "1.2*" ,minWidth: 50},
    ];

    InvReconDrugWj = [
        {header: "Drug Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true, width: "*" ,minWidth: 50},
    ];

    customReportListWJ = [
        {header: "Report Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Created By", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Created Dt Tm", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Last Modified By", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Last Modified Dt Tm", isVisible: true, width: "2*" ,minWidth: 50},
    ];
    deferredEquivalentsWJ = [
        {header: "Rx#", isVisible: true,  width: 87 ,minWidth: 50},
        {header: "Auth#", isVisible: true,  width: 45 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 37 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 34 ,minWidth: 50},
        {header: "Insurance", isVisible: true,  width: 72 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: 260 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true ,  width: 87 ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 150 ,minWidth: 50},
        {header: "NDC", isVisible: true,  width: 100 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 259 ,minWidth: 50},
        {header: "Refills Left", isVisible: false, width: 49 ,minWidth: 50},
    ];
    deferredEqvGrpWJ = [
        {header: "Rx#", isVisible: true,  width: 87 ,minWidth: 50},
        {header: "Auth#", isVisible: true,  width: 45 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 37 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 34 ,minWidth: 50},
        {header: "Insurance", isVisible: true,  width: 72 ,minWidth: 50},
        {header: "Status", isVisible: true, width: 50 ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: 260 ,minWidth: 50},
        {header: "Qty Dis", isVisible: true ,  width: 87 ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: 51 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 150 ,minWidth: 50},
        {header: "NDC", isVisible: true,  width: 100 ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: 259 ,minWidth: 50},
        {header: "Refills Left", isVisible: false, width: 49 ,minWidth: 50},
    ]
    prevoiusRefillsWJ = [
        {header: "Rx#", isVisible: true,  width: "1*" ,minWidth: 50},
        {header:  "Ref#", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Order Qty", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Disp Qty", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Days", isVisible: true ,  width: "1.5*" ,minWidth: 50},
    ]
    prevoiusFillsWJ = [
        {header: "Fill#", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Disp Qty", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Days", isVisible: true ,  width: "1*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Ing. Cost", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "U&C", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Copay", isVisible: true,  width: "1*" ,minWidth: 50},
    ]
    dscsaListWJ = [
        {header: "Name", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "API URL", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Pharmacy Access Key", isVisible: true ,  width: "2*" ,minWidth: 50},
    ]
    RxHistoryCurrentView  = [
        {header: "Rx#", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Auth#", isVisible: true,  width: "0.7*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Refills Left", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Insurance", isVisible: true,  width: "1*" ,minWidth: 50},
        {header: "Status", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "NDC", isVisible: true,  width: "1.3*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "2*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Rf and Def Due Date", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty Disp", isVisible: true, width: "1.3*" ,minWidth: 50}
    ];
    pillCounterListWJ = [
        {header: "Active", isVisible: true ,  width: 58 ,minWidth: 50},
        {header: "Interface Name", isVisible: true, width: 145 ,minWidth: 50},
        {header: "Machine Name", isVisible: true,  width: 176 ,minWidth: 50},
        {header: "IP Address", isVisible: true ,  width: 105 ,minWidth: 50},
        {header: "Port No.", isVisible: true,  width: 90 ,minWidth: 50},
        {header: "Image Port No.", isVisible: true ,  width: 90 ,minWidth: 50},
        {header: "Mode", isVisible: true, width: 90 ,minWidth: 50},
        {header: "Printer", isVisible: true,  width: 198 ,minWidth: 50}
    ];
    remittanceDataSetListWJ = [
        {header: "Rx#", isVisible: true, width: 62 ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: 45 ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: 45 ,minWidth: 50},
        {header: "Ins. Code", isVisible: true, width: 84 ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: 180 ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: 200 ,minWidth: 50},
        {header: "Amount Billed", isVisible: true, width: 67 ,minWidth: 50},
        {header: "Amount Approved", isVisible: true, width: 82 ,minWidth: 50},
        {header: "Reimbursements", isVisible: true, width: 121 ,minWidth: 50},
        {header: "Diff. Amount", isVisible: true, width: 97 ,minWidth: 50},
        {header: "Remittance Status", isVisible: true, width: 112 ,minWidth: 50},
        {header: "Authorization#", isVisible: true, width: 118 ,minWidth: 50},
        {header: "Cheque#", isVisible: true, width: 100 ,minWidth: 50},
        {header: "Cheque Date", isVisible: true, width: 112 ,minWidth: 50},
        {header: "CARC", isVisible: true, width: 68 ,minWidth: 50},
        {header: "CAMA", isVisible: true, width: 68 ,minWidth: 50},
        {header: "Payor Name", isVisible: true, width: 220 ,minWidth: 50},
        {header: "Fill Date", isVisible: true, width: 125 ,minWidth: 50},
        {header: "Date Applied", isVisible: true, width: 125 ,minWidth: 50},
        {header: "Auth#", isVisible: false, width: 45 ,minWidth: 50},
        {header: "Bin", isVisible: false, width: 66 ,minWidth: 50},
        {header: "Priority", isVisible: false, width: 112 ,minWidth: 50},
        {header: "CAGC", isVisible: false, width: 125 ,minWidth: 50},
    ]

    drugSuggestListWj = [
        {header: "Drug Name", isVisible: true,  width: "3*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Size", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Pck/Unit Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Pck/Unit AWP", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Made By", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Last Disp", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "D/C Date", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Drug Type", isVisible: true,  width: "1.5*" ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Brand?", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Equ.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Gen.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is Pref?", isVisible: true, width: "0.9*" ,minWidth: 50}
    ];

    drugEquListWj = [
        {header: "Drug Name", isVisible: true, width: "2.6*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Size", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Pck/Unit Cost", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Pck/Unit AWP", isVisible: true, width: "1.6*"  ,minWidth: 50},
        {header: "Made By", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Qty on Hand", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Last Disp", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "D/C Date", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Drug Type", isVisible: true,  width: "1.7*" ,minWidth: 50},
        {header: "Brand Name", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Generic Name", isVisible: true, width: "1.4*" ,minWidth: 50},        
        {header: "Brand?", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Equ.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Gen.Avl?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is Pref?", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Is 340B", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Inv?", isVisible: true, width: "*" ,minWidth: 50},
    ];
        
    drugRequesteDetails = [
        {header: "Drug Name", isVisible: true,  width: "3.5*" ,minWidth: 50},
        {header: "NDC", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Brand", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "AWP", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Cost", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Size", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Manufacturer", isVisible: true,  width: "3.1*" ,minWidth: 50},
        {header: "Drug Class", isVisible: true,  width: "0.9*" ,minWidth: 50}
    ];

    paQueueWj = [
        {header: "Rx#", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Ref#", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Fill#", isVisible: true, width: "0.5*" ,minWidth: 50},
        {header: "Date Filled", isVisible: true,  width: "1.2*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Drug NDC", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Qty", isVisible: true, width: "1.3*" ,minWidth: 50},
        {header: "Patient Name", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "1.6*"  ,minWidth: 50},
        {header: "Ins Code (BIN/PCN)", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "PA Created DtTm", isVisible: true, width: "1.4*" ,minWidth: 50},
        {header: "Rx Status", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "PA Vendor", isVisible: true, width: "1.4*" ,minWidth: 50},
    ];

    RxsTransferIn = [
        {header: "Transfer Mode", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Rx#", isVisible: true,  width: "0.82*" ,minWidth: 50},
        {header: "Auth#", isVisible: true,  width: "0.5*" ,minWidth: 50},
        {header: "Days Supply", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Refills Left", isVisible: true, width: "0.45*" ,minWidth: 50},  
        {header: "Status", isVisible: true,  width: "0.5*" ,minWidth: 50},
        {header: "Disp Qty / Ord Qty", isVisible: true ,  width: "0.95*" ,minWidth: 50},
        {header: "T.Rx Qty Rem", isVisible: true, width: "0.7*" ,minWidth: 50},
        {header: "Qty Being Transferred", isVisible: true, width: "0.85*" ,minWidth: 50},
        {header: "Refill# to be Transferred", isVisible: true, width: "0.85*" ,minWidth: 50},
        {header: "Fill DateTm", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: "2*" ,minWidth: 50},
        {header: "Prescriber Name", isVisible: true, width: "1.9*" ,minWidth: 50},
        {header: "Sig", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "eRx Recvd DateTm", isVisible: true, width: "1.8*" ,minWidth: 50},
        {header: "Insurance", isVisible: true,  width: "1*" ,minWidth: 50}
    ]
    PatientExternalHistoryWJ = [
        {header: "Rx#", isVisible: true,  width: "0.8*" ,minWidth: 50},
        {header: "Drug Name", isVisible: true,  width: "2.3*" ,minWidth: 50},
        {header: "Refills Left", isVisible: true,  width: "0.8*" ,minWidth: 50},
        {header: "Ordered Date", isVisible: true ,  width: "1.6*" ,minWidth: 110},
        {header: "Fill Date", isVisible: true, width: "1.6*" ,minWidth: 110},
        {header: "Days Supply", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Qty Disp", isVisible: true, width: "0.9*" ,minWidth: 50},
        {header: "Expiration Date", isVisible: true,  width: "1.6*" ,minWidth: 110},
        {header: "Active Rx?", isVisible: true, width: "1*" ,minWidth: 50},
        {header: "Source Pharmacy", isVisible: true, width: "1.7*" ,minWidth: 50},
        {header: "Added By", isVisible: true, width: "1.2*" ,minWidth: 50},
        {header: "Notes", isVisible: true, width: "2*" ,minWidth: 50}
    ]

    patientSuggestListWj = [
        {header: "Patient Name", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "DOB", isVisible: true,  width: "0.9*" ,minWidth: 50},
        {header: "Gender", isVisible: true, width: "0.8*" ,minWidth: 50},
        {header: "Address", isVisible: true,  width: "2.6*" ,minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1.1*" ,minWidth: 50},
        {header: "Ins. Code", isVisible: true, width: "1.5*" ,minWidth: 50},
        {header: "Ins. ID", isVisible: true, width: "1.6*" ,minWidth: 50},
        {header: "Facility Code", isVisible: true,  width: "1.6*" ,minWidth: 50},
        {header: "Email", isVisible: true, width: "2.2*" ,minWidth: 50},
        {header: "Chart#", isVisible: true, width: "1.6*"  ,minWidth: 50},
    ];
    erxListingWJRequestView = [
        {header: "Message Type", isVisible: true, width: 170, minWidth : 170, maxWidth: 170},
        {header: "Status", isVisible: true, width: 145, minWidth : 149, maxWidth: 145},
        {header: "Date & Time", isVisible: true, width: 141, minWidth : 141, maxWidth: 141},
        {header: "Prescriber Name", isVisible: true, width: 210, minWidth : 215, maxWidth: 215},
        {header: "Drug Name", isVisible: true, width: 210, minWidth : 215, maxWidth: 215},
        {header: "Last Filled", isVisible: true, width: 100, minWidth : 100, maxWidth: 100},
        {header: "Auth#", isVisible: true, width: 55, minWidth : 55, maxWidth: 55},
        {header: "Rx#", isVisible: true, width: 62, minWidth : 62, maxWidth: 62},
        {header: "Rph Notes", isVisible: true, width: 92, minWidth : 92, maxWidth: 92},
        {header: "Drug Class", isVisible: true, width: 56, minWidth : 80, maxWidth: 80},
        {header: "Primary Insurance", isVisible: true, width: 150, minWidth : 148, maxWidth: 150}
    ];

    cutoffTimeReminderWJ = [
        {header: "Reminder Mode", isVisible: true, width: 120 ,minWidth: 50},
        {header: "Vendor Name", isVisible: true, width: 230 ,minWidth: 50},
        {header: "Cut-Off Time", isVisible: true, width: 128 ,minWidth: 50},
        {header: "Remind Before", isVisible: true, width: 245 ,minWidth: 50}
    ];

    ivrWorkStationsListWj = [
        {header: "Active", isVisible: true,  width: "0.5*", minWidth: 50},
        {header: "Work Station Name", isVisible: true, width: "4*", minWidth: 50},
        {header: "Ext #", isVisible: true, width: "0.8*", minWidth: 50},
        {header: "Auto-Answer", isVisible: true, width: "1*", minWidth: 50}
    ]

    prescriberSuggestListWj = [
        {header: "Prescriber Name", isVisible: true, width: "2*", minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1.1*", minWidth: 50},
        {header: "Address", isVisible: true, width: "3.5*", minWidth: 50},
        {header: "NPI#", isVisible: true, width: "1.2*", minWidth: 50},
        {header: "License#", isVisible: true, width: "1.7*", minWidth: 50},
        {header: "DEA#", isVisible: true, width: "2*", minWidth: 50}
    ];

    ivrCallLogListWj = [
        {header: "Date & Time", isVisible: true, width: "1.3*", minWidth: 50},
        {header: "Call Duration (HH:MM:SS)", isVisible: true, width: "1.3*", minWidth: 50},
        {header: "Contact", isVisible: true, width: "1*", minWidth: 50},
        {header: "Contact Number", isVisible: true, width: "1*", minWidth: 50},
        {header: "Call Direction", isVisible: true, width: "1*", minWidth: 50},
        {header: "Call Mode", isVisible: true, width: "1*", minWidth: 50},
        {header: "Reason(s)", isVisible: true, width: "3*", minWidth: 50},
        {header: "By User", isVisible: true, width: "1*", minWidth: 50}
        
    ]

    patientMatchListWj = [
        {header: "Patient Name", isVisible: true, width: "2.5*", minWidth: 50},
        {header: "DOB", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Gender", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*", minWidth: 50},
        {header: "Address", isVisible: true, width: "2.4*", minWidth: 50},
    ]

    prescriberMatchListWj = [
        {header: "Prescriber Name", isVisible: true, width: "3.4*", minWidth: 50},
        {header: "NPI", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*", minWidth: 50},
        {header: "Address", isVisible: true, width: "2.4*", minWidth: 50},
    ]

    insuracneMatchListWj = [
        {header: "Insurance Name", isVisible: true, width: "2.5*", minWidth: 50},
        {header: "Insurance Code", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Payor", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*", minWidth: 50},
        {header: "BIN/PCN", isVisible: true, width: "2.4*", minWidth: 50}
    ]

    extPharmacyMatchListWj = [
        {header: "Other Pharmacy Name", isVisible: true, width: "2.5*", minWidth: 50},
        {header: "NPI#", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "eRx Xfer Avlbl", isVisible: true, width: "0.9*", minWidth: 50},
        {header: "Phone#", isVisible: true, width: "1*", minWidth: 50},
        {header: "Address", isVisible: true, width: "2.4*", minWidth: 50},
    ]

    rxTransferListWj = [
        {header: "Rx#", isVisible: true, width: "1*", minWidth: 50},
        {header: "Refills Transferred", isVisible: true, width: "1*", minWidth: 50},
        {header: "Transfer Type (In/Out)", isVisible: true, width: "1*", minWidth: 50},
        {header: "Transfer Pharmacy", isVisible: true, width: "1.5*", minWidth: 50},
        {header: "From RPh", isVisible: true, width: "2*", minWidth: 50},
        {header: "To RPh", isVisible: true, width: "2*", minWidth: 50},
        {header: "Org Rx#", isVisible: true, width: "1.5*", minWidth: 50},
        {header: "Org Rx Date", isVisible: true, width: "1.7*", minWidth: 50},
        {header: "Fill Date", isVisible: true, width: "1.5*", minWidth: 50},
        {header: "Transfer Date", isVisible: true, width: "1.7*", minWidth: 50},
    ]
}
